import { GoogleCloudStorageLocationAdapter } from './datasets/location/google-cloud-storage.location.adapter';
import { GoogleCloudStorageStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/google-cloud-storage-store-read-settings.adapter';
import { GoogleCloudStorageLinkedServiceAdapter } from './linkedservices/google-cloud-storage-linkedservice.adapter';
import { AzureCosmosV2CopySourceAdapter } from './activities/copysource/azure-cosmos.v2.copysource.adapter';
import { AzureMariaDBTableDatasetAdapter } from './datasets/azure-maria-db-dataset.adapter';
import { AzureMariaDBLinkedServiceAdapter } from './linkedservices/azure-maria-db-linkedservice.adapter';
import { AzureMariaDBCopySourceAdapter } from './activities/copysource/azure-maria-db.copysource.adapter';
import { MysqlTableDatasetAdapter } from './datasets/mysql-table.dataset.adapter';
import { SybaseTableDatasetAdapter } from './datasets/sybase-table.dataset.adapter';
import { SybaseCopySourceAdapter } from './activities/copysource/sybase.copysource.adapter';
import { SapBwCubeDatasetAdapter } from './datasets/sap-bw-cube.dataset.adapter';
import { AvroCopySourceAdapter } from './activities/copysource/avro.source.adapter';
import { AvroFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/avro-format-write-settings.adapter';
import { JsonCopySourceAdapter } from './activities/copysource/json.source.adapter';
import { JsonSinkAdapter } from './activities/copysink/json.sink.adapter';
import { JsonFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/json-format-write-settings.adapter';
import { DynamicsCrmLinkedServiceAdapter } from './linkedservices/dynamics-crm-linkedservice.adapter';
import { DynamicsCrmSinkAdapter } from 'app/model/adapters/activities/copysink/dynamics-crm.sink.adapter';
import { CommonDataServiceEntityDatasetAdapter } from './datasets/common-data-service.dataset.adapter';
import { CommonDataServiceLinkedServiceAdapter } from './linkedservices/common-data-service-linkedservice.adapter';
import { CommonDataServiceCopySourceAdapter } from './activities/copysource/common-data-service.copysource.adapter';
import { CommonDataServiceSinkAdapter } from './activities/copysink/common-data-service.sink.adapter';
import { InformixTableDatasetAdapter } from './datasets/informix-table-dataset.adapter';
import { InformixLinkedServiceAdapter } from './linkedservices/informix-linkedservice.adapter';
import { InformixCopySourceAdapter } from './activities/copysource/informix.copysource.adapter';
import { InformixSinkAdapter } from './activities/copysink/informix.sink.adapter';
import { MicrosoftAccessTableDatasetAdapter } from './datasets/microsoft-access-table-dataset.adapter';
import { MicrosoftAccessLinkedServiceAdapter } from './linkedservices/microsoft-access-linkedservice.adapter';
import { DelimitedTextDatasetAdapter } from './datasets/delimitedtext.dataset.adapter';
import { AzureDataLakeLocationAdapter } from './datasets/location/azure-datalake.location.adapter';
import { AzureBlobFSLocationAdapter } from './datasets/location/azure-blobfs.location.adapter';
import { AzureBlobStorageLocationAdapter } from './datasets/location/azure-blob.location.adapter';
import { ParquetDatasetAdapter } from './datasets/parquet.dataset.adapter';
import { SnowflakeTableDatasetAdapter } from './datasets/snowflake-dataset.adapter';
import { SnowflakeLinkedServiceAdapter } from './linkedservices/snowflake-linkedservice.adapter';
import { AzureDataBricksLinkedServiceAdapter } from './linkedservices/azure-data-bricks-linkedservice.adapter';
import { AzureFunctionActivityAdapter } from './activities/azure-function-activity.adapter';
import { NotebookActivityAdapter } from './activities/databricks-notebook.adapter';
import { RelationalCopySourceAdapter } from './activities/copysource/relational.copysource.adapter';
import { RelationalTableDatasetAdapter } from './datasets/relational-table.dataset.adapter';
import { SapHanaLinkedServiceAdapter } from './linkedservices/saphana-linkedservice.adapter';
import { SapBwLinkedServiceAdapter } from './linkedservices/sapbw-linkedservice.adapter';
import { AzureDataLakeStoreSinkAdapter } from './activities/copysink/datalakestore.sink.adapter';
import { FileSystemSinkAdapter } from './activities/copysink/filesystem.sink.adapter';
import { OracleSinkAdapter } from './activities/copysink/oracle.sink.adapter';
import { SqlSinkAdapter } from './activities/copysink/sql.sink.adapter';
import { BlobSinkAdapter } from './activities/copysink/blob.sink.adapter';
import { UsqlActivityAdapter } from './activities/usql-activity.adapter';
import { ScopeActivityAdapter } from './activities/scope-activity.adapter';
import { AzureDataLakeAnalyticsLinkedServiceAdapter } from './linkedservices/azure-data-lake-analytics-linkedservice.adapter';
import { HDInsightOnDemandLinkedServiceAdapter } from './linkedservices/hdinsightondemand-linkedservice.adapter';
import { PipelineAsyncAdapter } from './pipeline.adapter';
import { HDInsightSparkActivityAdapter } from './activities/hdinsight-spark-activity.adapter';
import { ParameterAdapter } from './parameter.adapter';
import { VariableAdapter } from './variable.adapter';
import { AzureStorageLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-storage-linkedservice.adapter';
import { AzureBlobDatasetAdapter } from 'app/model/adapters/datasets/azure-blob-dataset.adapter';
import { HDInsightLinkedServiceAdapter } from 'app/model/adapters/linkedservices/hdinsight-linkedservice.adapter';
import { AmazonS3LinkedServiceAdapter } from 'app/model/adapters/linkedservices/amazon-s3-linkedservice.adapter';
import { AmazonS3CompatibleLinkedServiceAdapter } from 'app/model/adapters/linkedservices/amazon-s3-compatible-linkedservice.adapter';
import { OracleCloudStorageLinkedServiceAdapter } from 'app/model/adapters/linkedservices/oracle-cloud-storage-linkedservice.adapter';
import { ForEachActivityAdapter } from 'app/model/adapters/activities/foreach-activity.adapter';
import {
    ExecutePipelineActivityAdapter,
    ExecutePipelineActivityDuplicateAdapter
} from 'app/model/adapters/activities/execute-pipeline-activity.adapter';
import { GetMetadataActivityAdapter } from 'app/model/adapters/activities/get-metadata-activity.adapter';
import { LookupActivityAdapter } from 'app/model/adapters/activities/lookup-activity.adapter';
import { AzureSqlDWLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-sql-dw-linkedservice.adapter';
import { AmazonS3DatasetAdapter } from 'app/model/adapters/datasets/amazon-s3-dataset.adapter';
import { SqlServerLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sql-server-linkedservice.adapter';
import { AzureSqlDWDatasetAdapter } from './datasets/azure-sql-dw-table-dataset.adapter';
import { ManagedIntegrationRuntimeAdapter } from 'app/model/adapters/integrationRuntime/managed-integrationRuntime.adapter';
import { ManagedLinkedIntegrationRuntimeAdapter } from 'app/model/adapters/integrationRuntime/managedlinked-integrationRuntime.adapter';
import { SelfHostedIntegrationRuntimeAdapter } from 'app/model/adapters/integrationRuntime/selfhosted-integrationRuntime.adapter';
import { SqlServerTableDatasetAdapter } from 'app/model/adapters/datasets/sql-server-table.dataset.adapter';
import { WebActivityAdapter } from 'app/model/adapters/activities/web-activity.adapter';
import { MapReduceActivityAdapter } from 'app/model/adapters/activities/mapreduce-activity.adapter';
import { HDInsightStreamingActivityAdapter } from 'app/model/adapters/activities/hdinsight-streaming-activity.adapter';
import { StoredProcedureActivityAdapter } from 'app/model/adapters/activities/stored-procedure-activity.adapter';
import { CustomActivityAdapter } from 'app/model/adapters/activities/custom-activity.adapter';
import { CopyActivityAsyncAdapter } from 'app/model/adapters/activities/copy-activity.adapter';

import { AzureSqlLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-sql-linkedservice.adapter';
import { AzureSqlDatasetAdapter } from 'app/model/adapters/datasets/azure-sql-table-dataset.adapter';
import { MountedRelationalDatabaseDatasetAdapter } from 'app/model/adapters/datasets/mounted-relational-table-dataset.adapter';
import { AzureDataLakeStoreLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-data-lake-store-linkedservice.adapter';
import { AzureDataLakeStoreCosmosStructuredStreamLinkedServiceAdapter } from './linkedservices/azure-data-lake-store-cosmos-structured-stream-linkedservice.adapter';
import { AzureDataLakeStoreGen2CosmosStructuredStreamLinkedServiceAdapter } from './linkedservices/azure-data-lake-store-gen2-cosmos-structured-stream-linkedservice.adapter';
import { OracleLinkedServiceAdapter } from 'app/model/adapters/linkedservices/oracle-linkedservice.adapter';
import { AzureDataLakeStoreFileDatasetAdapter } from 'app/model/adapters/datasets/azure-data-lake-store-file-dataset.adapter';
import { AzureDataLakeStoreCosmosStructuredStreamFileDatasetAdapter } from './datasets/azure-data-lake-store-cosmos-structured-stream-file-dataset.adapter';
import { AzureDataLakeStoreGen2CosmosStructuredStreamFileDatasetAdapter } from './datasets/azure-data-lake-store-gen2-cosmos-structured-stream-file-dataset.adapter';
import { FileSystemLinkedServiceAdapter } from 'app/model/adapters/linkedservices/file-server-linkedservice.adapter';
import { OracleTableDatasetAdapter } from 'app/model/adapters/datasets/oracle-table.dataset.adapter';
import { FileShareDatasetAdapter } from 'app/model/adapters/datasets/file-share-dataset.adapter';
import { HDInsightHiveActivityAdapter } from 'app/model/adapters/activities/hdinsight-hive-activity.adapter';
import { HDInsightPigActivityAdapter } from 'app/model/adapters/activities/hdinsight-pig-activity.adapter';
import { TriggerAdapter } from 'app/model/adapters/triggers/trigger.adapter';
import { AzureBatchLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-batch-linkedservice.adapter';
import { AzureFunctionLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-function-linkedservice.adapter';
import { SqlDWSinkAdapter } from 'app/model/adapters/activities/copysink/sqldw.sink.adapter';
import { AzureBlobCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-blob.copysource.adapter';
import { FileSystemCopySourceAdapter } from 'app/model/adapters/activities/copysource/file-system.copysource.adapter';
import { AzureDataLakeStoreFileCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-data-lake-store.copysource.adapter';
import { AzureDataLakeStoreCosmosStructuredStreamFileCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-data-lake-store-cosmos-structured-stream.copysource.adapter';
import { AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-data-lake-store-gen2-cosmos-structured-stream.copysource.adapter';
import { SqlCopySourceAdapter } from 'app/model/adapters/activities/copysource/sql.copysource.adapter';
import { SqlDWCopySourceAdapter } from 'app/model/adapters/activities/copysource/sqldw.copysource.adapter';
import { OracleCopySourceAdapter } from 'app/model/adapters/activities/copysource/oracle.copysource.adapter';
import { GenericActivityAdapter } from 'app/model/adapters/activities/generic-activity.adapter';
import { IfConditionActivityAdapter } from 'app/model/adapters/activities/if-condition-activity.adapter';
import { SwitchActivityAdapter } from 'app/model/adapters/activities/switch-activity.adapter';
import { UntilActivityAdapter } from 'app/model/adapters/activities/until-activity.adapter';
import { WaitActivityAdapter } from 'app/model/adapters/activities/wait-activity.adapter';
import { FailActivityAdapter } from 'app/model/adapters/activities/fail-activity.adapter';
import { SalesforceLinkedServiceAdapter } from 'app/model/adapters/linkedservices/salesforce-linkedservice.adapter';
import { SalesforceDatasetAdapter } from 'app/model/adapters/datasets/salesforce-dataset.adapter';
import { AzureKeyVaultLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-key-vault-linkedservice.adapter';
import { MySqlLinkedServiceAdapter } from 'app/model/adapters/linkedservices/mysql-linkedservice.adapter';
import { SalesforceCopySourceAdapter } from 'app/model/adapters/activities/copysource/salesforce.copysource.adapter';
import { SalesforceSinkAdapter } from 'app/model/adapters/activities/copysink/salesforce.sink.adapter';
import { AmazonRedshiftLinkedServiceAdapter } from 'app/model/adapters/linkedservices/amazon-redshift-linkedservice.adapter';
import { AmazonRedshiftCopySourceAdapter } from 'app/model/adapters/activities/copysource/amazon-redshift.copysource.adapter';
import { AmazonRedshiftSinkAdapter } from 'app/model/adapters/activities/copysink/amazon-redshift.sink.adapter';
import { HdfsLinkedServiceAdapter } from 'app/model/adapters/linkedservices/hdfs-linkedservice.adapter';
import { AzureMySqlLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-db-mysql-linkedservice.adapter';
import { AzureMySqlDatasetAdapter } from 'app/model/adapters/datasets/azure-mysql-table-dataset.adapter';
import { AzureCosmosLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-cosmos-db-linkedservice.adapter';
import { OdbcLinkedServiceAdapter } from 'app/model/adapters/linkedservices/odbc-linkedservice.adapter';
import { OdbcSinkAdapter } from 'app/model/adapters/activities/copysink/odbc.sink.adapter';
import { HdfsCopySourceAdapter } from 'app/model/adapters/activities/copysource/hdfs.copysource.adapter';
import { AzureMySqlCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-mysql.copysource.adapter';
import { AzureTableDatasetAdapter } from 'app/model/adapters/datasets/azure-table-dataset.adapter';
import { AzureTableCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-table.copysource.adapter';
import { AzureTableSinkAdapter } from './activities/copysink/azure-table.sink.adapter';
import { AzureCosmosDatasetAdapter } from 'app/model/adapters/datasets/azure-cosmos-dataset.adapter';
import { AzureCosmosCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-cosmos.copysource.adapter';
import { AzureCosmosDbSinkAdapter } from 'app/model/adapters/activities/copysink/azure-cosmos-db.sink.adapter';
import { CassandraLinkedServiceAdapter } from 'app/model/adapters/linkedservices/cassandra-linkedservice.adapter';
import { CassandraDatasetAdapter } from 'app/model/adapters/datasets/cassandra-dataset.adapter';
import { CassandraCopySourceAdapter } from 'app/model/adapters/activities/copysource/cassandra.copysource.adapter';
import { AzureSearchLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-search-linkedservice.adapter';
import { AzureSearchDatasetAdapter } from 'app/model/adapters/datasets/azure-search-dataset.adapter';
import { AzureSearchSinkAdapter } from 'app/model/adapters/activities/copysink/azure-search.sink.adapter';
import { AzurePostgreSqlLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-db-postgre-linkedservice.adapter';
import { AzureHorizonDBLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-horizon-db-linkedservice.adapter';
import { AzurePostgreSqlDatasetAdapter } from 'app/model/adapters/datasets/azure-postgre-sql-table-dataset.adapter';
import { AzureHorizonDBDatasetAdapter } from 'app/model/adapters/datasets/azure-horizon-db-table-dataset.adapter';
import { AzurePostgreSqlCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-postgre-sql.copysource.adapter';
import { AzureHorizonDBCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-horizon-db.copysource.adapter';
import { Db2LinkedServiceAdapter } from 'app/model/adapters/linkedservices/db2-linkedservice.adapter';
import { MongoDbLinkedServiceAdapter } from 'app/model/adapters/linkedservices/mongo-db-linkedservice.adapter';
import { MongoDbDatasetAdapter } from 'app/model/adapters/datasets/mongo-db-dataset.adapter';
import { MongoDbCopySourceAdapter } from 'app/model/adapters/activities/copysource/mongo-db.copysource.adapter';
import { FtpServerLinkedServiceAdapter } from 'app/model/adapters/linkedservices/ftp-server-linkedservice.adapter';
import { SftpLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sftp-server-linkedservice.adapter';
import { SybaseLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sybase-linkedservice.adapter';
import { TeradataLinkedServiceAdapter } from 'app/model/adapters/linkedservices/teradata-linkedservice.adapter';
import { ODataLinkedServiceAdapter } from 'app/model/adapters/linkedservices/odata-linkedservice.adapter';
import { ODataResourceDatasetAdapter } from 'app/model/adapters/datasets/odata-resource.dataset.adapter';
import { PostgreSqlLinkedServiceAdapter } from 'app/model/adapters/linkedservices/postgre-sql-linkedservice.adapter';
import { HttpLinkedServiceAdapter } from 'app/model/adapters/linkedservices/http-server-linkedservice.adapter';
import { HttpFileDatasetAdapter } from 'app/model/adapters/datasets/http-file-dataset.adapter';
import { HttpFileCopySourceAdapter } from 'app/model/adapters/activities/copysource/http-file.copysource.adapter';
import { GoogleBigQueryLinkedServiceAdapter } from 'app/model/adapters/linkedservices/google-bigquery-linkedservice.adapter';
import { GoogleBigQueryObjectDatasetAdapter } from 'app/model/adapters/datasets/google-bigquery-dataset.adapter';
import { GoogleBigQueryCopySourceAdapter } from 'app/model/adapters/activities/copysource/google-bigquery.copysource.adapter';
import { ImpalaCopySourceAdapter } from 'app/model/adapters/activities/copysource/impala.copysource.adapter';
import { ImpalaLinkedServiceAdapter } from 'app/model/adapters/linkedservices/impala-linkedservice.adapter';
import { ImpalaObjectDatasetAdapter } from 'app/model/adapters/datasets/impala-dataset.adapter';
import { ServiceNowCopySourceAdapter } from 'app/model/adapters/activities/copysource/servicenow.copysource.adapter';
import { ServiceNowLinkedServiceAdapter } from 'app/model/adapters/linkedservices/servicenow-linkedservice.adapter';
import { ServiceNowObjectDatasetAdapter } from 'app/model/adapters/datasets/servicenow-dataset.adapter';
import { FilterActivityAdapter } from 'app/model/adapters/activities/filter-activity.adapter';
import { ExecuteSSISPackageActivityAdapter } from 'app/model/adapters/activities/ssis-activity.adapter';
import { SourceAdapter } from 'app/model/adapters/dataflow/source.adapter';
import { SinkAdapter } from 'app/model/adapters/dataflow/sink.adapter';
import { DataFlowAdapter } from 'app/model/adapters/dataflow/dataflow.adapter';
import { DeriveTransformationAdapter } from 'app/model/adapters/dataflow/transformations/derive-transformation.adapter';
import { ExecuteDataFlowActivityAdapter } from 'app/model/adapters/activities/execute-dataflow-activity.adapter';
import { Office365CopySourceAdapter } from './activities/copysource/office365.copysource.adapter';
import { Office365LinkedServiceAdapter } from 'app/model/adapters/linkedservices/office365-linkedservice.adapter';
import { Office365DatasetAdapter } from 'app/model/adapters/datasets/office365-table.dataset.adapter';
import { DynamicsSinkAdapter } from 'app/model/adapters/activities/copysink/dynamics.sink.adapter';
import { DynamicsCopySourceAdapter } from 'app/model/adapters/activities/copysource/dynamics.copysource.adapter';
import { DynamicsLinkedServiceAdapter } from 'app/model/adapters/linkedservices/dynamics-linkedservice.adapter';
import { DynamicsEntityDatasetAdapter } from './datasets/dynamics-entity.dataset.adapter';
import { JoinTransformationAdapter } from 'app/model/adapters/dataflow/transformations/join-transformation.adapter';
import { FolderAdapter } from 'app/model/adapters/folder.adapter';
import { AmazonMWSCopySourceAdapter } from './activities/copysource/amazon-mws.copysource.adapter';
import { AmazonMWSLinkedServiceAdapter } from './linkedservices/amazon-mws-linkedservice.adapter';
import { AmazonMWSObjectDatasetAdapter } from './datasets/amazon-mws-dataset.adapter';
import { SapC4CSinkAdapter } from './activities/copysink/sapc4c.sink.adapter';
import { SapC4CCopySourceAdapter } from './activities/copysource/sapc4c.copysource.adapter';
import { SapC4CLinkedServiceAdapter } from './linkedservices/sapc4c-linkedservice.adapter';
import { SapC4CResourceDatasetAdapter } from './datasets/sapc4c-dataset.adapter';
import { SapEccCopySourceAdapter } from './activities/copysource/sap-ecc.copysource.adapter';
import { SapEccLinkedServiceAdapter } from './linkedservices/sap-ecc-linkedservice.adapter';
import { SapEccResourceDatasetAdapter } from './datasets/sap-ecc-dataset.adapter';
import { ExistsTransformationAdapter } from 'app/model/adapters/dataflow/transformations/exists-transformation.adapter';
import { HbaseLinkedServiceAdapter } from './linkedservices/hbase-linkedservice.adapter';
import { HbaseObjectDatasetAdapter } from './datasets/hbase-dataset.adapter';
import { HbaseCopySourceAdapter } from './activities/copysource/hbase.copysource.adapter';
import { HiveCopySourceAdapter } from './activities/copysource/hive.copysource.adapter';
import { HiveLinkedServiceAdapter } from './linkedservices/hive-linkedservice.adapter';
import { HiveObjectDatasetAdapter } from './datasets/hive-dataset.adapter';
import { SparkCopySourceAdapter } from './activities/copysource/spark.copysource.adapter';
import { SparkLinkedServiceAdapter } from './linkedservices/spark-linkedservice.adapter';
import { SparkObjectDatasetAdapter } from './datasets/spark-dataset.adapter';
import { PhoenixCopySourceAdapter } from './activities/copysource/phoenix.copysource.adapter';
import { PhoenixLinkedServiceAdapter } from './linkedservices/phoenix-linkedservice.adapter';
import { PhoenixObjectDatasetAdapter } from './datasets/phoenix-dataset.adapter';
import { PaypalObjectDatasetAdapter } from './datasets/paypal-dataset.adapter';
import { PaypalLinkedServiceAdapter } from './linkedservices/paypal-linkedservice.adapter';
import { PaypalCopySourceAdapter } from './activities/copysource/paypal.copysource.adapter';
import { MarketoObjectDatasetAdapter } from './datasets/marketo-dataset.adapter';
import { MarketoLinkedServiceAdapter } from './linkedservices/marketo-linkedservice.adapter';
import { MarketoCopySourceAdapter } from './activities/copysource/marketo.copysource.adapter';
import { KustoCopySourceAdapter } from './activities/copysource/kusto.copysource.adapter';
import { KustoLinkedServiceAdapter } from './linkedservices/kusto-linkedservice.adapter';
import { KustoDatasetAdapter } from './datasets/kusto-table.dataset.adapter';
import { OracleResponsysLinkedServiceAdapter } from 'app/model/adapters/linkedservices/oracle-responsys-linkedservice.adapter';
import { OracleResponsysDatasetAdapter } from 'app/model/adapters/datasets/oracle-responsys-dataset.adapter';
import { OracleResponsysCopySourceAdapter } from 'app/model/adapters/activities/copysource/oracle-responsys.copysource.adapter';
import { SalesforceMarketingCloudCopySourceAdapter } from './activities/copysource/salesforce-marketing-cloud.copysource.adapter';
import { SalesforceMarketingCloudLinkedServiceAdapter } from './linkedservices/salesforce-marketing-cloud-linkedservice.adapter';
import { SalesforceMarketingCloudDatasetAdapter } from './datasets/salesforce-marketing-cloud-dataset.adapter';
import { PrestoCopySourceAdapter } from 'app/model/adapters/activities/copysource/presto.copysource.adapter';
import { PrestoLinkedServiceAdapter } from 'app/model/adapters/linkedservices/presto-linkedservice.adapter';
import { PrestoObjectDatasetAdapter } from 'app/model/adapters/datasets/presto-dataset.adapter';
import { XeroCopySourceAdapter } from './activities/copysource/xero.copysource.adapter';
import { SquareCopySourceAdapter } from './activities/copysource/square.copysource.adapter';
import { XeroLinkedServiceAdapter } from './linkedservices/xero-linkedservice.adapter';
import { SquareLinkedServiceAdapter } from './linkedservices/square-linkedservice.adapter';
import { XeroObjectDatasetAdapter } from './datasets/xero-dataset.adapter';
import { SquareObjectDatasetAdapter } from './datasets/square-dataset.adapter';
import { JiraObjectDatasetAdapter } from 'app/model/adapters/datasets/jira-dataset.adapter';
import { JiraLinkedServiceAdapter } from 'app/model/adapters/linkedservices/jira-linkedservice.adapter';
import { JiraCopySourceAdapter } from 'app/model/adapters/activities/copysource/jira.copysource.adapter';
import { VivaInsightsReportDatasetAdapter } from 'app/model/adapters/datasets/viva-insights-report-dataset.adapter';
import { VivaInsightsLinkedServiceAdapter } from 'app/model/adapters/linkedservices/viva-insights-linkedservice.adapter';
import { VivaInsightsCopySourceAdapter } from 'app/model/adapters/activities/copysource/viva-insights.copysource.adapter';
import { GenericCDataLinkedServiceAdapter } from 'app/model/adapters/linkedservices/generic-cdata-linkedservice.adapter';
import { GenericCDataCopySourceAdapter } from 'app/model/adapters/activities/copysource/generic-cdata.copysource.adapter';
import { GenericCDataTableDatasetAdapter } from 'app/model/adapters/datasets/generic-cdata-table.dataset.adapter';
import { AttioObjectDatasetAdapter } from 'app/model/adapters/datasets/attio-dataset.adapter';
import { AttioLinkedServiceAdapter } from 'app/model/adapters/linkedservices/attio-linkedservice.adapter';
import { AttioCopySourceAdapter } from 'app/model/adapters/activities/copysource/attio.copysource.adapter';
import { BitbucketTableDatasetAdapter } from 'app/model/adapters/datasets/bitbucket-dataset.adapter';
import { OracleFusionTableDatasetAdapter } from 'app/model/adapters/datasets/oracle-fusion-dataset.adapter';
import { BitbucketLinkedServiceAdapter } from 'app/model/adapters/linkedservices/bitbucket-linkedservice.adapter';
import { OracleFusionLinkedServiceAdapter } from 'app/model/adapters/linkedservices/oracle-fusion-linkedservice.adapter';
import { BitbucketCopySourceAdapter } from 'app/model/adapters/activities/copysource/bitbucket.copysource.adapter';
import { OracleFusionCopySourceAdapter } from 'app/model/adapters/activities/copysource/oracle-fusion.copysource.adapter';
import { ShopifyCopySourceAdapter } from './activities/copysource/shopify.copysource.adapter';
import { MagentoCopySourceAdapter } from './activities/copysource/magento.copysource.adapter';
import { ShopifyLinkedServiceAdapter } from './linkedservices/shopify-linkedservice.adapter';
import { MagentoLinkedServiceAdapter } from './linkedservices/magento-linkedservice.adapter';
import { ShopifyObjectDatasetAdapter } from './datasets/shopify-dataset.adapter';
import { MagentoObjectDatasetAdapter } from './datasets/magento-dataset.adapter';
import { ConcurCopySourceAdapter } from './activities/copysource/concur.copysource.adapter';
import { HubSpotCopySourceAdapter } from './activities/copysource/hub-spot.copysource.adapter';
import { ConcurLinkedServiceAdapter } from './linkedservices/concur-linkedservice.adapter';
import { HubSpotLinkedServiceAdapter } from './linkedservices/hub-spot-linkedservice.adapter';
import { ConcurObjectDatasetAdapter } from './datasets/concur-dataset.adapter';
import { HubSpotObjectDatasetAdapter } from './datasets/hub-spot-dataset.adapter';
import { ZohoCopySourceAdapter } from './activities/copysource/zoho.copysource.adapter';
import { QuickBooksCopySourceAdapter } from './activities/copysource/quick-books.copysource.adapter';
import { EloquaCopySourceAdapter } from './activities/copysource/eloqua.copysource.adapter';
import { ZohoLinkedServiceAdapter } from './linkedservices/zoho-linkedservice.adapter';
import { EloquaLinkedServiceAdapter } from './linkedservices/eloqua-linkedservice.adapter';
import { QuickBooksLinkedServiceAdapter } from './linkedservices/quick-books-linkedservice.adapter';
import { ZohoObjectDatasetAdapter } from './datasets/zoho-dataset.adapter';
import { QuickBooksObjectDatasetAdapter } from './datasets/quick-books-dataset.adapter';
import { EloquaObjectDatasetAdapter } from './datasets/eloqua-dataset.adapter';
import { SelectTransformationAdapter } from 'app/model/adapters/dataflow/transformations/select-transformation.adapter';
import { WebCopySourceAdapter } from './activities/copysource/web.copysource.adapter';
import { WebTableLinkedServiceAdapter } from './linkedservices/web-table-linkedservice.adapter';
import { WebTableDatasetAdapter } from './datasets/web-table-dataset.adapter';
import { CouchbaseCopySourceAdapter } from './activities/copysource/couchbase.copysource.adapter';
import { CouchbaseLinkedServiceAdapter } from './linkedservices/couchbase-linkedservice.adapter';
import { CouchbaseTableDatasetAdapter } from './datasets/couchbase-dataset.adapter';
import { DrillCopySourceAdapter } from './activities/copysource/drill.copysource.adapter';
import { DrillLinkedServiceAdapter } from './linkedservices/drill-linkedservice.adapter';
import { DrillTableDatasetAdapter } from './datasets/drill-dataset.adapter';
import { GreenplumTableDatasetAdapter } from './datasets/greenplum-dataset.adapter';
import { GreenplumLinkedServiceAdapter } from './linkedservices/greenplum-linkedservice.adapter';
import { GreenplumCopySourceAdapter } from './activities/copysource/greenplum.copysource.adapter';
import { MariaDBCopySourceAdapter } from './activities/copysource/maria-db.copysource.adapter';
import { MariaDBLinkedServiceAdapter } from './linkedservices/maria-db-linkedservice.adapter';
import { MariaDBTableDatasetAdapter } from './datasets/maria-db-dataset.adapter';
import { NetezzaTableDatasetAdapter } from './datasets/netezza-dataset.adapter';
import { NetezzaLinkedServiceAdapter } from './linkedservices/netezza-linkedservice.adapter';
import { NetezzaCopySourceAdapter } from './activities/copysource/netezza.copysource.adapter';
import { KustoActivityAdapter } from 'app/model/adapters/activities/kusto-activity.adapter';
import { KqlActivityAdapter } from 'app/model/adapters/activities/kql-activity.adapter';
import { FilterTransformationAdapter } from 'app/model/adapters/dataflow/transformations/filter-transformation.adapter';
import { VerticaCopySourceAdapter } from 'app/model/adapters/activities/copysource/vertica.copysource.adapter';
import { VerticaLinkedServiceAdapter } from './linkedservices/vertica-linkedservice.adapter';
import { VerticaTableDatasetAdapter } from './datasets/vertica-dataset.adapter';
import { AggregateTransformationAdapter } from 'app/model/adapters/dataflow/transformations/aggregate-transformation.adapter';
import { SortTransformationAdapter } from 'app/model/adapters/dataflow/transformations/sort-transformation.adapter';
import { RankTransformationAdapter } from 'app/model/adapters/dataflow/transformations/rank-transformation.adapter';
import { ConditionalSplitTransformationAdapter } from 'app/model/adapters/dataflow/transformations/conditional-split.adapter';
import { AzureMLLinkedServiceAdapter } from './linkedservices/azure-ml-linkedservice.adapter';
import { AzureBlobFSLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-blob-fs-linkedservice.adapter';
import { AzureBlobFSDatasetAdapter } from 'app/model/adapters/datasets/azure-blob-fs-dataset.adapter';
import { AzureBlobFSCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-blob-fs.copysource.adapter';
import { AzureBlobFSSinkAdapter } from 'app/model/adapters/activities/copysink/azure-blob-fs.sink.adapter';
import { UnionTransformationAdapter } from 'app/model/adapters/dataflow/transformations/union-transformation.adapter';
import { NativeMongoDbCopySourceAdapter } from 'app/model/adapters/activities/copysource/native-mongo-db.copysource.adapter';
import { NativeMongoDbLinkedServiceAdapter } from 'app/model/adapters/linkedservices/native-mongo-db-linkedservice.adapter';
import { NativeMongoDbDatasetAdapter } from 'app/model/adapters/datasets/native-mongo-db-dataset.adapter';
import { MongoDbAtlasCopySourceAdapter } from 'app/model/adapters/activities/copysource/mongo-db-atlas.copysource.adapter';
import { MongoDbAtlasLinkedServiceAdapter } from 'app/model/adapters/linkedservices/mongo-db-atlas-linkedservice.adapter';
import { MongoDbAtlasDatasetAdapter } from 'app/model/adapters/datasets/mongo-db-atlas-dataset.adapter';
import { AzureCosmosMongoDbApiDatasetAdapter } from 'app/model/adapters/datasets/azure-cosmos-mongodb-api-dataset.adapter';
import { AzureCosmosMongoDbApiLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-cosmos-db-mongodb-api-linkedservice.adapter';
import { AzureCosmosMongoDbApiCopySourceAdapter } from 'app/model/adapters/activities/copysource/azure-cosmos-mongo-api.copysource.adapter';
import { AzureCosmosMongoDbApiSinkAdapter } from 'app/model/adapters/activities/copysink/azure-cosmos-mongodb-api.sink.adapter';
import { AzureBlobStorageLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-blob-storage-linkedservice.adapter';
import { AzureTableStorageLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-table-storage-linkedservice.adapter';
import { JarActivityAdapter } from 'app/model/adapters/activities/databricks-jar-activity.adapter';
import { PythonActivityAdapter } from 'app/model/adapters/activities/databricks-python-activity.adapter';
import { JobActivityAdapter } from 'app/model/adapters/activities/databricks-job-activity.adapter';
import { TagAdapter } from './tag.adapter';
import { RestServiceLinkedServiceAdapter } from 'app/model/adapters/linkedservices/rest-service-linkedservice.adapter';
import { RestResourceDatasetAdapter } from './datasets/rest-resource-dataset.adapter';
import { RestResourceCopySourceAdapter } from './activities/copysource/rest-resource.copysource.adapter';
import { RestResourceCopySinkAdapter } from './activities/copysink/rest-resource.copysink.adapter';
import { VariablesActivityAdapter } from './activities/variables-activity.adapter';
import { OracleServiceCloudCopySourceAdapter } from './activities/copysource/oracle-service-cloud.copysource.adapter';
import { OracleServiceCloudLinkedServiceAdapter } from './linkedservices/oracle-service-cloud-linkedservice.adapter';
import { OracleServiceCloudObjectDatasetAdapter } from './datasets/oracle-service-cloud-dataset.adapter';
import { GoogleAdWordsObjectDatasetAdapter } from './datasets/google-adwords-dataset.adapter';
import { GoogleAdWordsLinkedServiceAdapter } from './linkedservices/google-adwords-linkedservice.adapter';
import { GoogleAdWordsCopySourceAdapter } from './activities/copysource/google-adwords.copysource.adapter';
import { LookupTransformationAdapter } from 'app/model/adapters/dataflow/transformations/lookup-transformation.adapter';
import { AppendVariablesActivityAdapter } from './activities/variables-append-activity.adapter';
import { SurrogateKeyTransformationAdapter } from 'app/model/adapters/dataflow/transformations/surrogateKey-transformation.adapter';
import { ExtendTransformationAdapter } from 'app/model/adapters/dataflow/transformations/extend-transformation.adapter';
import { DynamicsAXCopySourceAdapter } from './activities/copysource/dynamics-ax.copysource.adapter';
import { DynamicsAXLinkedServiceAdapter } from './linkedservices/dynamics-ax-linkedservice.adapter';
import { DynamicsAXResourceDatasetAdapter } from './datasets/dynamics-ax-resource-dataset.adapter';
import { DeleteActivityAdapter } from './activities/delete-activity.adapter';
import { PivotTransformationAdapter } from 'app/model/adapters/dataflow/transformations/pivot-transformation.adapter';
import { SapOpenHubCopySourceAdapter } from './activities/copysource/sap-open-hub.copysource.adapter';
import { SapOpenHubTableDatasetAdapter } from './datasets/sap-open-hub-table-dataset.adapter';
import { SapOpenHubLinkedServiceAdapter } from './linkedservices/sap-open-hub-linkedservice.adapter';
import { UnpivotTransformationAdapter } from 'app/model/adapters/dataflow/transformations/unpivot-transformation.adapter';
import { WebHookActivityAdapter } from './activities/webhook-activity.adapter';
import { ExecuteWranglingDataflowActivity } from '../pipeline/execute-wrangling-dataflow.activity';
import { AzureDataExplorerLinkedServiceAdapter } from './linkedservices/azure-data-explorer-linkedservice.adapter';
import { AzureDataExplorerDatasetAdapter } from './datasets/azure-data-explorer-dataset.adapter';
import { AzureDataExplorerSinkAdapter } from './activities/copysink/azure-data-explorer.sink.adapter';
import { AzureDataExplorerCopySourceAdapter } from './activities/copysource/azure-data-explorer.copysource.adapter';
import { WindowTransformationAdapter } from 'app/model/adapters/dataflow/transformations/window-transformation.adapter';
import { ParquetSinkAdapter } from './activities/copysink/parquet.sink.adapter';
import { DelimitedTextSinkAdapter } from './activities/copysink/delimitedtext.sink.adapter';
import { DelimitedTextCopySourceAdapter } from './activities/copysource/delimitedtext.source.adapter';
import { ParquetCopySourceAdapter } from './activities/copysource/parquet.source.adapter';
import { ValidationActivityAdapter } from './activities/validation-activity.adapter';
import { TemplateAdapter } from 'app/model/adapters/template.adapter';
import { SapTableCopySourceAdapter } from './activities/copysource/sap-table.copysource.adapter';
import { SapTableLinkedServiceAdapter } from './linkedservices/sap-table-linkedservice.adapter';
import { SapTableDatasetAdapter } from './datasets/sap-table-dataset.adapter';
import { JsonDatasetAdapter } from './datasets/json.dataset.adapter';
import { AlterRowTransformationAdapter } from 'app/model/adapters/dataflow/transformations/alter-row-transformation.adapter';
import { TeradataCopySourceAdapter } from './activities/copysource/teradata.copysource.adapter';
import { TeradataDatasetAdapter } from './datasets/teradata-dataset.adapter';
import { WranglingDataflowAdapter } from './wranglingDataflow/wranglingDataflow.adapter';
import { ExecuteWranglingDataflowActivityAdapter } from './activities/execute-wrangling-dataflow-activity.adapter';
import { AzureBlobStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/azure-blob-store-read-settings.adapter';
import { AzureBlobStoreWriteSettingsAdapter } from './activities/copysink/store-write-settings/azure-blob-store-write-settings.adapter';
import { DelimitedTextFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/delimited-text-format-read-settings.adapter';
import { DelimitedTextFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/delimited-text-format-write-settings.adapter';
import { AzureBlobFSStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/azure-blob-fs-store-read-settings.adapter';
import { AmazonS3StoreReadSettingsAdapter } from './activities/copysource/store-read-settings/s3-store-read-settings.adapter';
import { AmazonS3CompatibleStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/amazon-s3-compatible-store-read-settings.adapter';
import { OracleCloudStorageStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/oracle-cloud-storage-store-read-settings.adapter';
import { AzureDataLakeStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/azure-data-lake-store-read-settings.adapter';
import { FileServerStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/file-server-store-read-settings.adapter';
import { FtpStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/ftp-store-read-settings.adapter';
import { SftpStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/sftp-store-read-settings.adapter';
import { HttpStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/http-store-read-settings.adapter';
import { HdfsStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/hdfs-store-read-settings.adapter';
import { AzureBlobFSWriteSettingsAdapter } from './activities/copysink/store-write-settings/azure-blob-fs-store-write-settings.adapter';
import { AzureDataLakeStoreWriteSettingsAdapter } from './activities/copysink/store-write-settings/azure-data-lake-store-write-settings.adapter';
import { FileServerStoreWriteSettingsAdapter } from './activities/copysink/store-write-settings/file-server-store-write-settings.adapter';
import { HttpServerLocationAdapter } from './datasets/location/http-server.location.adapter';
import { SftpLocationAdapter } from './datasets/location/sftp.location.adapter';
import { HdfsLocationAdapter } from './datasets/location/hdfs.location.adapter';
import { AmazonS3LocationAdapter } from './datasets/location/amazon-s3.location.adapter';
import { FileServerLocationAdapter } from './datasets/location/file-server.location.adapter';
import { AzureSqlMILinkedServiceAdapter } from './linkedservices/azure-sql-mi-linkedservice.adapter';
import { AzureSqlMITableDatasetAdapter } from './datasets/azure-sql-mi-table.dataset.adapter';
import { SqlServerCopySourceAdapter } from './activities/copysource/sql-server.copysource.adapter';
import { SqlMICopySourceAdapter } from './activities/copysource/sql-mi.copysource.adapter';
import { AzureSqlCopySourceAdapter } from './activities/copysource/azure-sql.copysource.adapter';
import { SqlServerSinkAdapter } from './activities/copysink/sql.server.sink.adapter';
import { AzureSqlSinkAdapter } from './activities/copysink/azure.sql.sink.adapter';
import { SqlMISinkAdapter } from './activities/copysink/sql.mi.sink.adapter';
import { FtpServerLocationLocationAdapter } from './datasets/location/ftp-server.location.adapter';
import { BinaryCopySourceAdapter } from './activities/copysource/binary.source.adapter';
import { BinaryDatasetAdapter } from './datasets/binary.dataset.adapter';
import { AdobeExperiencePlatformLinkedServiceAdapter } from './linkedservices/adobe-experience-platform-linkedservice.adapter';
import { BinarySinkAdapter } from 'app/model/adapters/activities/copysink/binary.sink.adapter';
import { SapHanaDatasetAdapter } from './datasets/saphana-dataset.adapter';
import { SapHanaCopySourceAdapter } from './activities/copysource/saphana.copysource.adapter';
import { AdobeExperiencePlatformCopySourceAdapter } from './activities/copysource/adobe-experience-platform.copysource.adapter';
import { AdobeExperiencePlatformDatasetAdapter } from './datasets/adobe-experience-platform-dataset.adapter';
import { AzureDataExplorerCommandActivityAdapter } from './activities/azure-data-explorer-activity.adapter';
import {
    BigDataPoolAdapter,
    DatabaseAdapter,
    KqlScriptAdapter,
    LinkTableAdapter,
    LinkTopicAdapter,
    ManagedPrivateEndpointAdapter,
    ManagedVirtualNetworkAdapter,
    NotebookAdapter,
    SqlDatabaseAdapter,
    SqlPoolAdapter,
    SqlScriptAdapter
} from 'shell-models-lib';
import { AzurePostgreSQLSinkAdapter } from './activities/copysink/azure-postgre-sql.sink.adapter';
import { AzureHorizonDBSinkAdapter } from './activities/copysink/azure-horizon-db.sink.adapter';
import { A365SubResourceAdapter } from './a365SubResource.adapter';
import { MicrosoftAccessCopySourceAdapter } from './activities/copysource/microsoft-access.copysource.adapter';
import { MicrosoftAccessSinkAdapter } from 'app/model/adapters/activities/copysink/microsoft-access.sink.adapter';
import { DynamicsCrmCopySourceAdapter } from './activities/copysource/dynamics-crm.copysource.adapter';
import { DynamicsCrmEntityDatasetAdapter } from './datasets/dynamics-crm-entity.dataset.adapter';
import { SalesforceServiceCloudSinkAdapter } from 'app/model/adapters/activities/copysink/salesforce-service-cloud.sink.adapter';
import { SalesforceServiceCloudDatasetAdapter } from './datasets/salesforce-service-cloud-dataset.adapter';
import { SalesforceServiceCloudCopySourceAdapter } from './activities/copysource/salesforce-service-cloud.copysource.adapter';
import { SalesforceServiceCloudLinkedServiceAdapter } from './linkedservices/salesforce-service-cloud-linkedservice.adapter';
import { SapBwCopySourceAdapter } from './activities/copysource/sap-bw.copysource.adapter';
import { AvroDatasetAdapter } from './datasets/avro.dataset.adapter';
import { AvroSinkAdapter } from './activities/copysink/avro.sink.adapter';
import { AzureMySqlSinkAdapter } from './activities/copysink/azure-mysql.sink.adapter';
import { ODataCopySourceAdapter } from './activities/copysource/odata.copysource.adapter';
import { DB2DatasetAdapter } from './datasets/db2-dataset.adapter';
import { DB2CopySourceAdapter } from './activities/copysource/db2.copysource.adapter';
import { MysqlCopySourceAdapter } from './activities/copysource/mysql.copysource.adapter';
import { AmazonRedshiftTableDatasetAdapter } from './datasets/amazon-redshift-dataset.adapter';
import { OdbcCopySourceAdapter } from './activities/copysource/odbc.copysource.adapter';
import { OdbcDatasetAdapter } from './datasets/odbc-dataset.adapter';
import { PostgreSqlCopySourceAdapter } from './activities/copysource/postgre-sql.copysource.adapter';
import { PostgreSqlDatasetAdapter } from './datasets/postgre-sql-dataset.adapter';
import { OrcSinkAdapter } from './activities/copysink/orc.sink.adapter';
import { OrcCopySourceAdapter } from './activities/copysource/orc.source.adapter';
import { OrcDatasetAdapter } from './datasets/orc.dataset.adapter';
import { AzureCosmosDbV2SinkAdapter } from './activities/copysink/azure-cosmos-db.v2.sink.adapter';
import { AzureCosmosV2DatasetAdapter } from './datasets/azure-cosmos-dataset.v2.adapter';
import { AzureFileStorageLinkedServiceAdapter } from './linkedservices/azure-file-storage-linkedservice.adapter';
import { AzureFileStorageStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/azure-file-storage-store-read-settings.adapter';
import { AzureFileStorageStoreWriteSettingsAdapter } from './activities/copysink/store-write-settings/azure-file-storage-store-write-settings.adapter';
import { AzureFileStorageLocationAdapter } from './datasets/location/azure-file-storage.location.adapter';
import { SynapseNotebookActivityAdapter } from './activities/synapse-notebook.activity.adapter';
import { TridentNotebookActivityAdapter } from './activities/trident-notebook.activity.adapter';
import { TridentSparkJobDefinitionActivityAdapter } from './activities/trident-sparkjobdefinition.activity.adapter';
import { AzureMLServiceLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-ml-service-linkedservice.adapter';
import { AzureMLExecutePipelineActivityAdapter } from 'app/model/adapters/activities/azure-ml-execute-pipeline-activity.adapter';
import { SynapseSparkJobDefinitionActivityAdapter } from './activities/synapse-sparkjobdefinition-activity.adapter';
import { SynapseScopeJobDefinitionActivityAdapter } from './activities/synapse-scopejobdefinition-activity.adapter';
import { SqlPoolSinkAdapter } from './activities/copysink/sql-pool.sink.adapter';
import { SqlPoolCopySourceAdapter } from './activities/copysource/sql-pool.copysource.adapter';
import { SqlPoolTableDatasetAdapter } from './datasets/sql-pool-table-dataset.adapter';
import { PowerBIWorkspaceLinkedServiceAdapter } from './linkedservices/power-bi-workspace.linkedservice.adapter';
import { SynapseStoredProcedureActivityAdapter } from './activities/synapse-storedprocedure.activity.adapter';
import { SnowflakeSinkAdapter } from './activities/copysink/snowflake.sink.adapter';
import { FactoryAsyncAdapter } from './factory.adapter';
import { GlobalParameterAdapter } from './global-parameter.adapter';
import { SftpStoreWriteSettingsAdapter } from './activities/copysink/store-write-settings/sftp-store-write-settings.adapter';
import { GitHubLinkedServiceAdapter } from './linkedservices/github-linkedservice.adapter';
import { BrowseTransformationAdapter } from 'app/model/adapters/dataflow/transformations/browse-transformation.adapter';
import { ConnectTransformationAdapter } from 'app/model/adapters/dataflow/transformations/connect-transformation.adapter';
import { FoldDownTransformationAdapter } from 'app/model/adapters/dataflow/transformations/fold-down-transformation.adapter';
import { SnowflakeSourceAdapter } from './activities/copysource/snowflake.copysource.adapter';
import { ExcelDatasetAdapter } from './datasets/excel.dataset.adapter';
import { ExcelCopySourceAdapter } from './activities/copysource/excel.source.adapter';
import { SharePointOnlineListCopySourceAdapter } from './activities/copysource/sharepoint-online-list.copysource.adapter';
import { SharePointOnlineListLinkedServiceAdapter } from './linkedservices/sharepoint-online-list-linkedservice.adapter';
import { SharePointOnlineListResourceDatasetAdapter } from './datasets/sharepoint-online-list-resource-dataset.adapter';
import { SharePointOnlineFileLinkedServiceAdapter } from './linkedservices/sharepoint-online-file-linkedservice.adapter';
import { BinaryFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/binary-format-read-settings.adapter';
import { JsonFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/json-format-read-settings.adapter';
import { ZipDeflateCompressionReadSettingsAdapter } from './activities/copysource/compression-read-settings/zip-deflate-compression-read-settings.adapter';
import { XmlCopySourceAdapter } from 'app/model/adapters/activities/copysource/xml.copysource.adapter';
import { XmlDatasetAdapter } from './datasets/xml-dataset.adapter';
import { XmlFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/xml-format-read-settings.adapter';
import { AdobeIntegrationLinkedServiceAdapter } from './linkedservices/adobe-integrationi-linkedservice.adapter';
import { AdobeEventsFormatAdapter } from './dataflow/formatAdapters/adobe-events.adapter';
import { AdobeCampaignFormatAdapter } from './dataflow/formatAdapters/adobe-campaign.adapter';
import { CdmFormatAdapter } from './dataflow/formatAdapters/cdm.adapter';
import { DeltaFormatAdapter } from './dataflow/formatAdapters/delta.adapter';
import { AdobePrivacyFormatAdapter } from './dataflow/formatAdapters/adobe-privacy.adapter';
import { HiveFormatAdapter } from './dataflow/formatAdapters/hive.adapter';
import { ExcelFormatAdapter } from './dataflow/formatAdapters/excel.adapter';
import { XmlFormatAdapter } from './dataflow/formatAdapters/xml.adapter';
import { OrcFormatAdapter } from './dataflow/formatAdapters/orc.adapter';
import { SnowflakeTableAdapter } from './dataflow/formatAdapters/snowflake.adapter';
import { SynapseAnalyticsFormatAdapter } from './dataflow/formatAdapters/synapse-analytics.adapter';
import { SqlDBFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/sql-db.adapter';
import { AzureDatabricksDeltaLakeLinkedServiceAdapter } from './linkedservices/azure-databricks-delta-lake-linkedservice.adapter';
import { AzureDatabricksDeltaLakeDatasetAdapter } from './datasets/azure-databricks-delta-lake-dataset.adapter';
import { AzureDatabricksDeltaLakeSinkAdapter } from './activities/copysink/azure-databricks-delta-lake.sink.adapter';
import { AzureDatabricksDeltaLakeCopySourceAdapter } from './activities/copysource/azure-databricks-delta-lake.copysource.adapter';
import { DatabricksLinkedServiceAdapter } from './linkedservices/databricks-linkedservice.adapter';
import { DatabricksDatasetAdapter } from './datasets/databricks-dataset.adapter';
import { DatabricksSinkAdapter } from './activities/copysink/databricks.sink.adapter';
import { DatabricksCopySourceAdapter } from './activities/copysource/databricks.copysource.adapter';
import { TarGZipCompressionReadSettingsAdapter } from './activities/copysource/compression-read-settings/tar-gzip-compression-read-settings.adapter';
import { GroupAdapter } from './dataflow/group.adapter';
import { ParquetFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/parquet-format-write-settings.adapter';
import { OrcFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/orc-format-write-settings.adapter';
import { CredentialAdapter } from './credential.adapter';
import { PipelinePolicyAdapter } from './pipeline-policy.adapter';
import { PostgreSqlAdapter } from './dataflow/formatAdapters/postgre-sql.adapter';
import { TarCompressionReadSettingsAdapter } from './activities/copysource/compression-read-settings/tar-compression-read-settings.adapter';
import { DelimitedTextFormatAdapter } from './dataflow/formatAdapters/delimited-text.adapter';
import { ParseTransformationAdapter } from 'app/model/adapters/dataflow/transformations/parse-transformation.adapter';
import { AvroFormatAdapter } from './dataflow/formatAdapters/avro.adapter';
import { JsonFormatAdapter } from './dataflow/formatAdapters/json.adapter';
import { MysqlAdapter } from './dataflow/formatAdapters/mysql.adapter';
import { EventHubsLinkedServiceAdapter } from './linkedservices/event-hubs-linkedservice.adapter';
import { CognitiveServiceLinkedServiceAdapter } from './linkedservices/cognitive-service-linkedservice.adapter';
import { FlowletAdapter } from './dataflow/flowlet.adapter';
import { AmazonS3CompatibleLocationAdapter } from './datasets/location/amazon-s3-compatible.location.adapter';
import { OracleCloudStorageLocationAdapter } from './datasets/location/oracle-cloud-storage.location.adapter';
import { ExecuteFlowletTransformationAdapter } from 'app/model/adapters/dataflow/transformations/execute-flowlet.adapter';
import { OnPremiseSqlServerFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/on-premise-sql-server.adapter';
import { AirflowIntegrationRuntimeAdapter } from './integrationRuntime/airflow-integrationRuntime.adapter';
import { AirflowEntityAdapter } from './airflowEntity.adapter';
import { MongoDbAtlasCopySinkAdapter } from './activities/copysink/mongo-db-atlas.sink.adapter';
import { NativeMongoDbApiSinkAdapter } from './activities/copysink/native-mongo-db.sink.adapter';
import { ParquetFormatAdapter } from './dataflow/formatAdapters/parquet.adapter';
import { AssertTransformationAdapter } from 'app/model/adapters/dataflow/transformations/assert-transformation.adapter';
import { OutputAdapter } from './dataflow/output.adapter';
import { InputAdapter } from './dataflow/input.adapter';
import { RestFormatAdapter } from './dataflow/formatAdapters/rest.adapter';
import { RestCallFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/restCall.adapter';
import { AmazonRdsForOracleAdapter } from 'app/model/adapters/linkedservices/amazon-rds-for-oracle-linkedservice.adapter';
import { AmazonRdsForOracleDatasetAdapter } from 'app/model/adapters/datasets/amazon-rds-for-oracle.dataset.adapter';
import { AmazonRdsForOracleCopySourceAdapter } from 'app/model/adapters/activities/copysource/amazon-rds-for-oracle.copysource.adapter';
import { AmazonRdsSqlServerCopySourceAdapter } from 'app/model/adapters/activities/copysource/amazon-rds-sql-server.copysource.adapter';
import { AmazonRdsSqlServerLinkedServiceAdapter } from 'app/model/adapters/linkedservices/amazon-rds-sql-server-linkedservice.adapter';
import { AmazonRdsSqlServerTableDatasetAdapter } from 'app/model/adapters/datasets/amazon-rds-sql-server-table.dataset.adapter';
import { MappingArtifactAsyncAdapter } from './mappingArtifact/mapping-artifact.adapter';
import { AdfDataMapperArtifactAsyncAdapter } from './adfDataMapper/adfDataMapper.adapter';
import { AdxAdapter } from 'app/model/adapters/dataflow/formatAdapters/adx.adapter';
import { StringifyTransformationAdapter } from 'app/model/adapters/dataflow/transformations/stringify-transformation.adapter';
import { GuardTransformationAdapter } from 'app/model/adapters/dataflow/transformations/guard-transformation.adapter';
import { CallTransformationAdapter } from 'app/model/adapters/dataflow/transformations/call-transformation.adapter';
import { DynamicsAdapter } from 'app/model/adapters/dataflow/formatAdapters/dynamics.adapter';
import { UserDefinedFunctionLibraryAdapter } from './dataflow/user-defined-function-library.adapter';
import { DynamicsCrmAdapter } from 'app/model/adapters/dataflow/formatAdapters/dynamics-crm.adapter';
import { SapOdpLinkedServiceAdapter } from './linkedservices/sap-odp-linkedservice.adapter';
import { SapOdpCopySourceAdapter } from './activities/copysource/sap-odp.copysource.adapter';
import { SapOdpDatasetAdapter } from './datasets/sap-odp-dataset.adapter';
import { SharePointOnlineFileLocationAdapter } from './datasets/location/sharepoint-online-file.location.adapter';
import { Injectable } from '@angular/core';
import { ScriptActivityAdapter } from './activities/script-activity.adapter';
import { SharePointOnlineFileStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/sharepoint-online-file-store-read-settings.adapter';
import { TeamDeskLinkedServiceAdapter } from 'app/model/adapters/linkedservices/team-desk-linkedservice.adapter';
import { TeamDeskAdapter } from 'app/model/adapters/dataflow/formatAdapters/team-desk.adapter';
import { CosmosSqlAdapter } from './dataflow/formatAdapters/cosmos-sql.adapter';
import { CosmosMongoAdapter } from './dataflow/formatAdapters/cosmos-mongo.adapter';
import { QuickbaseLinkedServiceAdapter } from './linkedservices/quickbase-linkedservice.adapter';
import { SapOdpAdapter } from './dataflow/formatAdapters/sap-odp.adapter';
import { QuickbaseAdapter } from './dataflow/formatAdapters/quickbase.adapter';
import { SmartsheetLinkedServiceAdapter } from 'app/model/adapters/linkedservices/smartsheet-linkedservice.adapter';
import { SmartsheetAdapter } from 'app/model/adapters/dataflow/formatAdapters/smartsheet.adapter';
import { ZenDeskLinkedServiceAdapter } from 'app/model/adapters/linkedservices/zendesk-linkedservice.adapter';
import { ZendeskAdapter } from 'app/model/adapters/dataflow/formatAdapters/zendesk.adapter';
import { GlobalParametersARMAsyncAdapter } from './globalparameters-arm.adapter';
import { DataverseAdapter } from './dataflow/formatAdapters/dataverse.adapter';
import { TriggerSettingsAdapter } from './triggers/trigger-settings.adapter';
import { CastTransformationAdapter } from 'app/model/adapters/dataflow/transformations/cast-transformation.adapter';
import { AzureSynapseLinkedServiceAdapter } from 'app/model/adapters/linkedservices/azure-synapse-linkedservice.adapter';
import { LakehouseLinkedServiceAdapter } from './linkedservices/lakehouse-linkedservice.adapter';
import { LakehouseStoreReadSettingsAdapter } from './activities/copysource/store-read-settings/lakehouse-store-read-settings.adapter';
import { LakehouseLocationAdapter } from './datasets/location/lakehouse.location.adapter';
import { LakehouseWriteSettingsAdapter } from './activities/copysink/store-write-settings/lakehouse-store-write-settings.adapter';
import { DataflowRefreshActivityAdapter } from './activities/dataflow-refresh-activity.adapter';
import { SapCdcCopySourceAdapter } from 'app/model/adapters/activities/copysource/sap-cdc.copysource.adapter';
import { SapCdcDatasetAdapter } from 'app/model/adapters/datasets/sap-cdc-dataset.adapter';
import { SapCdcLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-cdc-linkedservice.adapter';
import { SapBdcLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-bdc-linkedservice.adapter';
import { SapBdcDatasetAdapter } from 'app/model/adapters/datasets/sap-bdc-dataset.adapter';
import { DeltaDatasetAdapter } from './datasets/delta.dataset.adapter';
import { DeltaFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/delta-format-write-settings.adapter';
import { PbiDataflowAdapter } from 'app/model/adapters/dataflow/pbiDataflow.adapter';
import { SqlMIFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/sql-mi.adapter';
import { TrinoLinkedServiceAdapter } from 'app/model/adapters/linkedservices/trino.linkedservice.adapter';
import { TrinoDatasetAdapter } from './datasets/trino-dataset.adapter';
import { TrinoCopySourceAdapter } from './activities/copysource/trino.copysource.adapter';
import { Microsoft365Adapter } from 'app/model/adapters/dataflow/formatAdapters/microsoft365.adapter';
import { OracleAdapter } from 'app/model/adapters/dataflow/formatAdapters/oracle.adapter';
import {
    AzureBlobStorageActivityAdapter,
    AzureDevOpsActivityAdapter,
    EmailActivityAdapter,
    InvokeADFPipelineActivityAdapter,
    TeamsActivityAdapter
} from './activities/extensible-activity.adapter';
import { WorkdayLinkedServiceAdapter } from 'app/model/adapters/linkedservices/workday-linkedservice.adapter';
import { WorkdayAdapter } from 'app/model/adapters/dataflow/formatAdapters/workday.adapter';
import { PbiNotebookAdapter } from './notebook/pbiNotebook.adapter';
import { KustoDatabaseDatasetAdapter } from 'app/model/adapters/datasets/kusto-database-dataset.adapter';
import { KustoDatabaseLinkedServiceAdapter } from 'app/model/adapters/linkedservices/kusto-database-linkedservice.adapter';
import { KustoDatabaseSinkAdapter } from 'app/model/adapters/activities/copysink/kusto-database.sink.adapter';
import { KustoDatabaseCopySourceAdapter } from 'app/model/adapters/activities/copysource/kusto-database.copysource.adapter';
import { DataWarehouseLinkedServiceAdapter } from './linkedservices/data-warehouse-linkedservice.adapter';
import { DataWarehouseTableDatasetAdapter } from './datasets/data-warehouse-table-dataset.adapter';
import { DataWarehouseSinkAdapter } from './activities/copysink/data-warehouse.sink.adapter';
import { DataWarehouseCopySourceAdapter } from './activities/copysource/data-warehouse.copysource.adapter';
import { LakehouseTableDatasetAdapter } from './datasets/lakehouse-table-dataset.adapter';
import { LakehouseTableCopySourceAdapter } from './activities/copysource/lakehouse-table.copysource.adapter';
import { EventHubsAdapter } from './dataflow/formatAdapters/event-hubs.adapter';
import { LakehouseTableCopySinkAdapter } from './activities/copysink/lakehouse-table.copysink.adapter';
import { DeltaSourceAdapter } from './activities/copysource/delta.source.adapter';
import { DeltaSinkAdapter } from './activities/copysink/delta.sink.adapter';
import { MountedRelationalDatabaseTableCopySinkAdapter } from './activities/copysink/mounted-relational-database-table.copysink.adapter';
import { ParquetFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/parquet-format-read-settings.adapter';
import { DeltaFormatReadSettingsAdapter } from './activities/copysource/format-read-settings/delta-format-read-settings.adapter';
import { SapOdataLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-odata-linkedservice.adapter';
import { SapOdataAdapter } from 'app/model/adapters/dataflow/formatAdapters/sap-odata.adapter';
import { SapODataDatasetAdapter } from 'app/model/adapters/datasets/sap-odata-dataset.adapter';
import { SapODataCopySourceAdapter } from 'app/model/adapters/activities/copysource/sap-odata.copysource.adapter';
import { KafkaAdapter } from './dataflow/formatAdapters/kafka.adapter';
import { WebActivityLinkedServiceAdapter } from './linkedservices/web-activity-linkedservice.adapter';
import { IcebergFormatAdapter } from './dataflow/formatAdapters/iceberg.adapter';
import { KafkaLinkedServiceAdapter } from './linkedservices/kafka-linkedservice.adapter';
import { AzureDataFactoryLinkedServiceAdapter } from './linkedservices/azure-data-factory-linkedservice.adapter';
import { FabricWorkspaceLinkedServiceAdapter } from './linkedservices/fabric-workspace-linkedservice.adapter';
import { AzureSynapseAnalyticsLinkedServiceAdapter } from './linkedservices/azure-synapse-analytics-linkedservice.adapter';
import { PowerBILinkedServiceAdapter } from './linkedservices/powerbi-linkedservice.adapter';
import { ColumnFlattenSettingsAdapter } from './activities/activity-column-flatten-settings.adapter';
import { AmazonS3WriteSettingsAdapter } from './activities/copysink/store-write-settings/amazon-s3-store-write-settings.adapter';
import { AmazonS3CompatibleWriteSettingsAdapter } from './activities/copysink/store-write-settings/amazon-s3-compatible-store-write-settings.adapter';
import { GoogleCloudStorageWriteSettingsAdapter } from './activities/copysink/store-write-settings/google-cloud-storage-store-write-settings.adapter';
import { SalesforceV2LinkedServiceAdapter } from './linkedservices/salesforce-v2-linkedservice.adapter';
import { SalesforceServiceCloudV2LinkedServiceAdapter } from './linkedservices/salesforce-service-cloud-v2-linkedservice.adapter';
import { SalesforceV2DatasetAdapter } from './datasets/salesforce-v2-dataset.adapter';
import { SalesforceServiceCloudV2DatasetAdapter } from './datasets/salesforce-service-cloud-v2-dataset.adapter';
import { SalesforceV2CopySourceAdapter } from './activities/copysource/salesforcev2.copysource.adapter';
import { SalesforceV2SinkAdapter } from './activities/copysink/salesforcev2.sink.adapter';
import { SalesforceAdapter } from './dataflow/formatAdapters/salesforce.adapter';
import { SalesforceServiceCloudV2CopySourceAdapter } from './activities/copysource/salesforce-service-cloud-v2.copysource.adapter';
import { SalesforceServiceCloudV2SinkAdapter } from './activities/copysink/salesforce-service-cloud-v2.sink.adapter';
import { SnowflakeV2LinkedServiceAdapter } from './linkedservices/snowflake-v2-linkedservice.adapter';
import { SnowflakeV2TableDatasetAdapter } from './datasets/snowflake-v2-dataset.adapter';
import { SnowflakeV2SourceAdapter } from './activities/copysource/snowflake-v2.copysource.adapter';
import { SnowflakeV2SinkAdapter } from './activities/copysink/snowflake-v2.sink.adapter';
import { GoogleBigQueryV2LinkedServiceAdapter } from './linkedservices/google-bigquery-v2-linkedservice.adapter';
import { GoogleBigQueryObjectV2DatasetAdapter } from './datasets/google-bigquery-dataset-v2.adapter';
import { GoogleBigQueryV2CopySourceAdapter } from './activities/copysource/google-bigquery-v2.copysource.adapter';
import { AirflowActivityAdapter } from './activities/webextensible/airflow-activity.adapter';
import { AzureKeyVaultActivityAdapter } from './activities/webextensible/azure-key-vault-activity.adapter';
import { PostgreSqlV2LinkedServiceAdapter } from './linkedservices/postgre-sql-v2-linkedservice.adapter';
import { PostgreSqlV2DatasetAdapter } from './datasets/postgre-sql-v2-dataset.adapter';
import { PostgreSqlV2CopySourceAdapter } from './activities/copysource/postgre-sql-v2.copysource.adapter';
import { ServiceNowV2LinkedServiceAdapter } from './linkedservices/servicenow-v2-linkedservice.adapter';
import { ServiceNowV2ObjectDatasetAdapter } from './datasets/servicenow-v2-dataset.adapter';
import { ServiceNowV2CopySourceAdapter } from './activities/copysource/servicenow-v2.copysource.adapter';
import { FabricDataPipelinesLinkedServiceAdapter } from './linkedservices/fabric-data-pipelines-linkedservice.adapter';
import { SnowflakeV2TableAdapter } from './dataflow/formatAdapters/snowflake-v2.adapter';
import { AzureHDInsightActivityAdapter } from './activities/azure-hdinsight-activity.adapter';
import { CopyJobAdapter } from 'app/model/adapters/copyjob/copy-job.adapter';
import { CopyJobActivityAsyncAdapter } from 'app/model/adapters/copyjob/copy-job-activity.adapter';
import { InvokeSSISPackageActivityAdapter } from './activities/ssis-activity.fabric.adapter';
import { WarehouseFormatAdapter } from './dataflow/formatAdapters/warehouse.adapter';
import { MicrosoftTeamsLinkedServiceAdapter } from './linkedservices/microsoft-teams-linkedservice.adapter';
import { MicrosoftOutlookLinkedServiceAdapter } from './linkedservices/microsoft-outlook-linkedservice.adapter';
import { FabricSqlLinkedServiceAdapter } from './linkedservices/fabric-sql-linkedservice.adapter';
import { FabricSqlCopySourceAdapter } from './activities/copysource/fabric-sql.copysource.adapter';
import { FabricSqlSinkAdapter } from './activities/copysink/fabric-sql.sink.adapter';
import { FabricSqlTableDatasetAdapter } from './datasets/fabric-sql-table-dataset.adapter';
import { IcebergDatasetAdapter } from './datasets/iceberg.dataset.adapter';
import { IcebergSinkAdapter } from './activities/copysink/iceberg.sink.adapter';
import { IcebergFormatWriteSettingsAdapter } from './activities/copysink/format-write-settings/iceberg-format-write-settings.adapter';
import { TridentSparkJobDefinitionLinkedServiceAdapter } from './linkedservices/trident-sparkjobdefinition-linkedservice.adapter';
import { FabricUserDataFunctionsLinkedServiceAdapter } from './linkedservices/fabric-userdatafunctions-linkedservice.adapter';
import { FabricNotebookLinkedServiceAdapter } from './linkedservices/fabric-notebook-linkedservice.adapter';
import { FabricAirflowLinkedServiceAdapter } from './linkedservices/fabric-airflow-linkedservice.adapter';
import { LibraryVariableAdapter } from './libraryvariable.adapter';
import { MountedRelationalDatabaseLinkedServiceAdapter } from './linkedservices/mounted-relational-database.linkedservice.adapter';
import { TeradataSinkAdapter } from './activities/copysink/teradata.sink.adapter';
import { FabricDataflowLinkedServiceAdapter } from './linkedservices/fabric-dataflow-linkedservice.adapter';
import { InvokeCopyJobActivityAdapter } from './activities/invoke-copyjob.activity.adapter';
import { InvokeCopyJobLinkedServiceAdapter } from './linkedservices/invoke-copyjob-linkedservice.adapter';
import { SqlAnalyticsEndpointLinkedServiceAdapter } from './linkedservices/sql-analytics-endpoint-linkedservice.adapter';
import { SqlAnalyticsEndpointDatasetAdapter } from './datasets/sql-analytics-endpoint-dataset.adapter';
import { SqlAnalyticsEndpointCopySourceAdapter } from './activities/copysource/sql-analytics-endpoint.copysource.adapter';
import { MicrosoftTeamsActivityAdapter } from './activities/microsoft-teams.activity.adapter';
import { Office365EmailActivityAdapter } from './activities/office365-email.activity.adapter';
import { Office365EmailLinkedServiceAdapter } from './linkedservices/office365-email-linkedservice.adapter';
import { LakehouseMaintenanceActivityAdapter } from './activities/webextensible/lakehouse-maintenance-activity.adapter';
import { RefreshSqlEndpointActivityAdapter } from './activities/webextensible/refreshsqlendpoint-activity.adapter';
import { FabricApprovalActivityAdapter } from './activities/fabric-approval.activity.adapter';
import { SapDatasphereForAzureDataLakeStorageGen2ReadSettingsAdapter } from 'app/model/adapters/activities/copysource/store-read-settings/sap-datasphere-for-azure-data-lake-storage-gen2-read-settings.adapter';
import { SapDatasphereForAzureDataLakeStorageGen2LocationAdapter } from 'app/model/adapters/datasets/location/sap-datasphere-for-azure-data-lake-storage-gen2.location.adapter';
import { SapDatasphereForAzureDataLakeStorageGen2LinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-datasphere-for-azure-data-lake-storage-gen2-linkedservice.adapter';
import { OneLakeFileReadSettingsAdapter } from 'app/model/adapters/activities/copysource/store-read-settings/one-lake-file-read-settings.adapter';
import { OneLakeFileWriteSettingsAdapter } from 'app/model/adapters/activities/copysink/store-write-settings/one-lake-file-store-write-settings.adapter';
import { OneLakeFileLocationAdapter } from 'app/model/adapters/datasets/location/one-lake-file.location.adapter';
import { OneLakeFileLinkedServiceAdapter } from 'app/model/adapters/linkedservices/one-lake-file-linkedservice.adapter';
import { SapDatasphereForGoogleCloudStorageLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-datasphere-for-google-cloud-storage-linkedservice.adapter';
import { SapDatasphereForGoogleCloudStorageLocationAdapter } from 'app/model/adapters/datasets/location/sap-datasphere-for-google-cloud-storage.location.adapter';
import { SapDatasphereForGoogleCloudStorageReadSettingsAdapter } from 'app/model/adapters/activities/copysource/store-read-settings/sap-datasphere-for-google-cloud-storage-read-settings.adapter';
import { SapDatasphereForAmazonS3LocationAdapter } from 'app/model/adapters/datasets/location/sap-datasphere-for-amazon-s3.location.adapter';
import { SapDatasphereForAmazonS3LinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-datasphere-for-amazon-s3-linkedservice.adapter';
import { SapDatasphereForAmazonS3ReadSettingsAdapter } from 'app/model/adapters/activities/copysource/store-read-settings/sap-datasphere-for-amazon-s3-read-settings.adapter';
import { RefreshMaterializedLakeViewActivityAdapter } from './activities/webextensible/refresh-materialized-lake-view-activity.adapter';
import { FabricSqlEndpointMetadataLinkedServiceAdapter } from './linkedservices/fabric-sql-endpoint-metadata-linkedservice.adapter';
import { InvokeDataBuildToolJobActivityAdapter } from './activities/invoke-databuildtooljob.activity.adapter';
import { InvokeDataQualityActivityAdapter } from './activities/invoke-dataquality.activity.adapter';
import { ApiIntegrationActivityAdapter } from './activities/api-integration.activity.adapter';
import { FabricActionsActivityAdapter } from './activities/fabric-actions.activity.adapter';
import { BusinessActionsActivityAdapter } from './activities/business-actions.activity.adapter';
import { FMLVLinkedServiceAdapter } from './linkedservices/fabric-materialized-lakehouse-view.adapter';
import { DataBuildToolJobLinkedServiceAdapter } from './linkedservices/data-build-tool-job-linkedservice.adapter';
import { DataQualityLinkedServiceAdapter } from './linkedservices/data-quality-linkedservice.adapter';
import { FabricWebLinkedServiceAdapter } from './linkedservices/fabric-web-linkedservice.adapter';

import { SharePointOnlineFileWriteSettingsAdapter } from './activities/copysink/store-write-settings/sharepoint-online-file-store-write-settings.adapter';
import { SemanticModelRefreshActivityAdapter } from './activities/webextensible/powerbi-semantic-model-refresh-activity.adapter';
import { MySqlSinkAdapter } from './activities/copysink/mysql.sink.adapter';
import { PostgreSqlV2SinkAdapter } from './activities/copysink/postgre-sql-v2.sink.adapter';
import { GoogleBigQueryV2SinkAdapter } from './activities/copysink/google-bigquery-v2.sink.adapter';
import { EventStreamLinkedServiceAdapter } from './linkedservices/event-stream-linkedservice.adapter';
import { EventStreamDatasetAdapter } from './datasets/event-stream-dataset.adapter';
import { EventStreamCopySourceAdapter } from './activities/copysource/event-stream.copysource.adapter';
import { EventStreamCopySinkAdapter } from './activities/copysink/event-stream.copysink.adapter';

/*
    List of all the adapters. The registry will load these up. TS does not allow
    a way to self discover these at runtime.
*/
@Injectable()
export class AdapterLoader {
    public static readonly adapters: Function[] = [
        // A365 resources
        NotebookAdapter,
        SqlScriptAdapter,
        KqlScriptAdapter,
        SqlPoolAdapter,
        SqlDatabaseAdapter,
        BigDataPoolAdapter,
        A365SubResourceAdapter,
        DatabaseAdapter,
        LinkTopicAdapter,
        LinkTableAdapter,

        // [DataFactory]
        FactoryAsyncAdapter,
        GlobalParameterAdapter,

        ManagedPrivateEndpointAdapter,
        ManagedVirtualNetworkAdapter,
        CredentialAdapter,

        // [GlobalParameters]
        GlobalParametersARMAsyncAdapter,

        // [Pipeline and Activity]
        PipelineAsyncAdapter,
        TagAdapter,
        HDInsightSparkActivityAdapter,
        WebActivityAdapter,
        HDInsightHiveActivityAdapter,
        HDInsightPigActivityAdapter,
        ForEachActivityAdapter,
        UsqlActivityAdapter,
        ScopeActivityAdapter,
        MapReduceActivityAdapter,
        HDInsightStreamingActivityAdapter,
        StoredProcedureActivityAdapter,
        ScriptActivityAdapter,
        ExecutePipelineActivityAdapter,
        ExecutePipelineActivityDuplicateAdapter,
        PipelinePolicyAdapter,
        GetMetadataActivityAdapter,
        LookupActivityAdapter,
        CustomActivityAdapter,
        CopyActivityAsyncAdapter,
        ColumnFlattenSettingsAdapter,
        ExecuteDataFlowActivityAdapter,
        DataflowRefreshActivityAdapter,
        IfConditionActivityAdapter,
        SwitchActivityAdapter,
        UntilActivityAdapter,
        WaitActivityAdapter,
        FailActivityAdapter,
        GenericActivityAdapter,
        NotebookActivityAdapter,
        JarActivityAdapter,
        PythonActivityAdapter,
        JobActivityAdapter,
        FilterActivityAdapter,
        TeamsActivityAdapter,
        MicrosoftTeamsActivityAdapter,
        Office365EmailActivityAdapter,
        EmailActivityAdapter,
        AzureBlobStorageActivityAdapter,
        AzureDevOpsActivityAdapter,
        InvokeADFPipelineActivityAdapter,
        ExecuteSSISPackageActivityAdapter,
        InvokeSSISPackageActivityAdapter,
        KustoActivityAdapter,
        KqlActivityAdapter,
        AzureDataExplorerCommandActivityAdapter,
        AzureMLExecutePipelineActivityAdapter,
        AzureFunctionActivityAdapter,
        AzureHDInsightActivityAdapter,
        VariablesActivityAdapter,
        AppendVariablesActivityAdapter,
        DeleteActivityAdapter,
        WebHookActivityAdapter,
        ExecuteWranglingDataflowActivity,
        ValidationActivityAdapter,
        ExecuteWranglingDataflowActivityAdapter,
        SynapseNotebookActivityAdapter,
        SynapseSparkJobDefinitionActivityAdapter,
        SynapseScopeJobDefinitionActivityAdapter,
        SynapseStoredProcedureActivityAdapter,
        AirflowActivityAdapter,
        SemanticModelRefreshActivityAdapter,
        AzureKeyVaultActivityAdapter,
        LakehouseMaintenanceActivityAdapter,
        RefreshMaterializedLakeViewActivityAdapter,
        RefreshSqlEndpointActivityAdapter,

        // [CopySink]
        SqlDWSinkAdapter,
        BlobSinkAdapter,
        SqlSinkAdapter,
        SqlPoolSinkAdapter,
        SqlServerSinkAdapter,
        AzureSqlSinkAdapter,
        SqlMISinkAdapter,
        AmazonRedshiftSinkAdapter,
        OracleSinkAdapter,
        FileSystemSinkAdapter,
        AzureDataLakeStoreSinkAdapter,
        SalesforceSinkAdapter,
        SalesforceV2SinkAdapter,
        OdbcSinkAdapter,
        AzureTableSinkAdapter,
        AzureCosmosDbSinkAdapter,
        AzureSearchSinkAdapter,
        DynamicsSinkAdapter,
        SapC4CSinkAdapter,
        AzureBlobFSSinkAdapter,
        AzureCosmosMongoDbApiSinkAdapter,
        MongoDbAtlasCopySinkAdapter,
        NativeMongoDbApiSinkAdapter,
        AzureDataExplorerSinkAdapter,
        KustoDatabaseSinkAdapter,
        DataWarehouseSinkAdapter,
        FabricSqlSinkAdapter,
        ParquetSinkAdapter,
        DeltaSinkAdapter,
        IcebergSinkAdapter,
        DelimitedTextSinkAdapter,
        JsonSinkAdapter,
        AvroSinkAdapter,
        OrcSinkAdapter,
        BinarySinkAdapter,
        AzurePostgreSQLSinkAdapter,
        AzureHorizonDBSinkAdapter,
        AzureMySqlSinkAdapter,
        MySqlSinkAdapter,
        GoogleBigQueryV2SinkAdapter,
        MicrosoftAccessSinkAdapter,
        CommonDataServiceSinkAdapter,
        DynamicsCrmSinkAdapter,
        InformixSinkAdapter,
        SalesforceServiceCloudSinkAdapter,
        SalesforceServiceCloudV2SinkAdapter,
        AzureCosmosDbV2SinkAdapter,
        SnowflakeSinkAdapter,
        SnowflakeV2SinkAdapter,
        AzureDatabricksDeltaLakeSinkAdapter,
        DatabricksSinkAdapter,
        TeradataSinkAdapter,
        EventStreamCopySinkAdapter,

        // [CopySource]
        AzureBlobCopySourceAdapter,
        FileSystemCopySourceAdapter,
        AzureDataLakeStoreFileCopySourceAdapter,
        AzureDataLakeStoreCosmosStructuredStreamFileCopySourceAdapter,
        AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySourceAdapter,
        SqlCopySourceAdapter,
        SqlPoolCopySourceAdapter,
        SqlServerCopySourceAdapter,
        AzureSqlCopySourceAdapter,
        SqlMICopySourceAdapter,
        SqlDWCopySourceAdapter,
        OracleCopySourceAdapter,
        SalesforceCopySourceAdapter,
        SalesforceV2CopySourceAdapter,
        RelationalCopySourceAdapter,
        DB2CopySourceAdapter,
        OdbcCopySourceAdapter,
        AmazonRedshiftCopySourceAdapter,
        AzureMySqlCopySourceAdapter,
        AzurePostgreSqlCopySourceAdapter,
        AzureHorizonDBCopySourceAdapter,
        SapTableCopySourceAdapter,
        HdfsCopySourceAdapter,
        AzureTableCopySourceAdapter,
        AzureCosmosCopySourceAdapter,
        MongoDbCopySourceAdapter,
        GoogleBigQueryCopySourceAdapter,
        GoogleBigQueryV2CopySourceAdapter,
        ImpalaCopySourceAdapter,
        ServiceNowCopySourceAdapter,
        ServiceNowV2CopySourceAdapter,
        CassandraCopySourceAdapter,
        Office365CopySourceAdapter,
        HttpFileCopySourceAdapter,
        DynamicsCopySourceAdapter,
        AmazonMWSCopySourceAdapter,
        SapC4CCopySourceAdapter,
        SapEccCopySourceAdapter,
        HbaseCopySourceAdapter,
        HiveCopySourceAdapter,
        KustoCopySourceAdapter,
        SparkCopySourceAdapter,
        PhoenixCopySourceAdapter,
        PaypalCopySourceAdapter,
        PostgreSqlCopySourceAdapter,
        PostgreSqlV2CopySourceAdapter,
        PostgreSqlV2SinkAdapter,
        MarketoCopySourceAdapter,
        OracleResponsysCopySourceAdapter,
        SalesforceMarketingCloudCopySourceAdapter,
        PrestoCopySourceAdapter,
        XeroCopySourceAdapter,
        SquareCopySourceAdapter,
        ShopifyCopySourceAdapter,
        MagentoCopySourceAdapter,
        JiraCopySourceAdapter,
        VivaInsightsCopySourceAdapter,
        GenericCDataCopySourceAdapter,
        AttioCopySourceAdapter,
        BitbucketCopySourceAdapter,
        OracleFusionCopySourceAdapter,
        WebCopySourceAdapter,
        ConcurCopySourceAdapter,
        HubSpotCopySourceAdapter,
        ZohoCopySourceAdapter,
        QuickBooksCopySourceAdapter,
        EloquaCopySourceAdapter,
        CouchbaseCopySourceAdapter,
        DrillCopySourceAdapter,
        GreenplumCopySourceAdapter,
        MariaDBCopySourceAdapter,
        NetezzaCopySourceAdapter,
        VerticaCopySourceAdapter,
        AzureBlobFSCopySourceAdapter,
        NativeMongoDbCopySourceAdapter,
        MongoDbAtlasCopySourceAdapter,
        AzureCosmosMongoDbApiCopySourceAdapter,
        OracleServiceCloudCopySourceAdapter,
        GoogleAdWordsCopySourceAdapter,
        RestResourceCopySourceAdapter,
        RestResourceCopySinkAdapter,
        SapOpenHubCopySourceAdapter,
        DynamicsAXCopySourceAdapter,
        TeradataCopySourceAdapter,
        AzureDataExplorerCopySourceAdapter,
        KustoDatabaseCopySourceAdapter,
        EventStreamCopySourceAdapter,
        DataWarehouseCopySourceAdapter,
        FabricSqlCopySourceAdapter,
        SqlAnalyticsEndpointCopySourceAdapter,
        ParquetCopySourceAdapter,
        DelimitedTextCopySourceAdapter,
        JsonCopySourceAdapter,
        AvroCopySourceAdapter,
        OrcCopySourceAdapter,
        BinaryCopySourceAdapter,
        ExcelCopySourceAdapter,
        SapHanaCopySourceAdapter,
        AdobeExperiencePlatformCopySourceAdapter,
        MicrosoftAccessCopySourceAdapter,
        CommonDataServiceCopySourceAdapter,
        DynamicsCrmCopySourceAdapter,
        InformixCopySourceAdapter,
        SalesforceServiceCloudCopySourceAdapter,
        SalesforceServiceCloudV2CopySourceAdapter,
        SybaseCopySourceAdapter,
        SapBwCopySourceAdapter,
        AzureMariaDBCopySourceAdapter,
        ODataCopySourceAdapter,
        MysqlCopySourceAdapter,
        AzureCosmosV2CopySourceAdapter,
        SnowflakeSourceAdapter,
        SnowflakeV2SourceAdapter,
        SharePointOnlineListCopySourceAdapter,
        XmlCopySourceAdapter,
        AzureDatabricksDeltaLakeCopySourceAdapter,
        DatabricksCopySourceAdapter,
        AmazonRdsForOracleCopySourceAdapter,
        AmazonRdsSqlServerCopySourceAdapter,
        SapOdpCopySourceAdapter,
        SapCdcCopySourceAdapter,
        SapODataCopySourceAdapter,
        TrinoCopySourceAdapter,
        LakehouseTableCopySourceAdapter,
        LakehouseTableCopySinkAdapter,
        DeltaSourceAdapter,
        DeltaSinkAdapter,
        DeltaFormatReadSettingsAdapter,
        MountedRelationalDatabaseTableCopySinkAdapter,

        // [LinkedService]
        AzureStorageLinkedServiceAdapter,
        AzureBlobStorageLinkedServiceAdapter,
        AzureTableStorageLinkedServiceAdapter,
        HDInsightLinkedServiceAdapter,
        HDInsightOnDemandLinkedServiceAdapter,
        AmazonS3LinkedServiceAdapter,
        AmazonS3CompatibleLinkedServiceAdapter,
        OracleCloudStorageLinkedServiceAdapter,
        AzureSqlDWLinkedServiceAdapter,
        AzureSqlLinkedServiceAdapter,
        PowerBIWorkspaceLinkedServiceAdapter,
        SqlServerLinkedServiceAdapter,
        AzureSqlMILinkedServiceAdapter,
        AzureDataLakeStoreLinkedServiceAdapter,
        AzureDataLakeStoreCosmosStructuredStreamLinkedServiceAdapter,
        AzureDataLakeStoreGen2CosmosStructuredStreamLinkedServiceAdapter,
        AzureDataLakeAnalyticsLinkedServiceAdapter,
        OracleLinkedServiceAdapter,
        FileSystemLinkedServiceAdapter,
        AzureBatchLinkedServiceAdapter,
        AzureFunctionLinkedServiceAdapter,
        SalesforceLinkedServiceAdapter,
        SalesforceV2LinkedServiceAdapter,
        AzureKeyVaultLinkedServiceAdapter,
        MySqlLinkedServiceAdapter,
        Db2LinkedServiceAdapter,
        SapBwLinkedServiceAdapter,
        SapHanaLinkedServiceAdapter,
        AmazonRedshiftLinkedServiceAdapter,
        HdfsLinkedServiceAdapter,
        FtpServerLinkedServiceAdapter,
        AzureMySqlLinkedServiceAdapter,
        AzurePostgreSqlLinkedServiceAdapter,
        AzureHorizonDBLinkedServiceAdapter,
        AzureCosmosLinkedServiceAdapter,
        OdbcLinkedServiceAdapter,
        AzureDataBricksLinkedServiceAdapter,
        SftpLinkedServiceAdapter,
        CassandraLinkedServiceAdapter,
        AzureSearchLinkedServiceAdapter,
        MongoDbLinkedServiceAdapter,
        SybaseLinkedServiceAdapter,
        TeradataLinkedServiceAdapter,
        ODataLinkedServiceAdapter,
        GoogleBigQueryLinkedServiceAdapter,
        GoogleBigQueryV2LinkedServiceAdapter,
        ImpalaLinkedServiceAdapter,
        ServiceNowLinkedServiceAdapter,
        ServiceNowV2LinkedServiceAdapter,
        PostgreSqlLinkedServiceAdapter,
        PostgreSqlV2LinkedServiceAdapter,
        Office365LinkedServiceAdapter,
        HttpLinkedServiceAdapter,
        DynamicsLinkedServiceAdapter,
        SapTableLinkedServiceAdapter,
        AmazonMWSLinkedServiceAdapter,
        SapC4CLinkedServiceAdapter,
        SapEccLinkedServiceAdapter,
        HbaseLinkedServiceAdapter,
        HiveLinkedServiceAdapter,
        KustoLinkedServiceAdapter,
        LakehouseLinkedServiceAdapter,
        EventStreamLinkedServiceAdapter,
        FMLVLinkedServiceAdapter,
        SparkLinkedServiceAdapter,
        PhoenixLinkedServiceAdapter,
        PaypalLinkedServiceAdapter,
        MarketoLinkedServiceAdapter,
        OracleResponsysLinkedServiceAdapter,
        SalesforceMarketingCloudLinkedServiceAdapter,
        PrestoLinkedServiceAdapter,
        XeroLinkedServiceAdapter,
        SquareLinkedServiceAdapter,
        ShopifyLinkedServiceAdapter,
        MagentoLinkedServiceAdapter,
        JiraLinkedServiceAdapter,
        VivaInsightsLinkedServiceAdapter,
        GenericCDataLinkedServiceAdapter,
        AttioLinkedServiceAdapter,
        BitbucketLinkedServiceAdapter,
        OracleFusionLinkedServiceAdapter,
        WebTableLinkedServiceAdapter,
        PowerBILinkedServiceAdapter,
        FabricDataPipelinesLinkedServiceAdapter,
        MicrosoftTeamsLinkedServiceAdapter,
        MicrosoftOutlookLinkedServiceAdapter,
        Office365EmailLinkedServiceAdapter,
        ConcurLinkedServiceAdapter,
        HubSpotLinkedServiceAdapter,
        ZohoLinkedServiceAdapter,
        EloquaLinkedServiceAdapter,
        QuickBooksLinkedServiceAdapter,
        CouchbaseLinkedServiceAdapter,
        DrillLinkedServiceAdapter,
        GreenplumLinkedServiceAdapter,
        MariaDBLinkedServiceAdapter,
        NetezzaLinkedServiceAdapter,
        VerticaLinkedServiceAdapter,
        AzureMLLinkedServiceAdapter,
        AzureMLServiceLinkedServiceAdapter,
        AzureBlobFSLinkedServiceAdapter,
        NativeMongoDbLinkedServiceAdapter,
        MongoDbAtlasLinkedServiceAdapter,
        AzureCosmosMongoDbApiLinkedServiceAdapter,
        OracleServiceCloudLinkedServiceAdapter,
        GoogleAdWordsLinkedServiceAdapter,
        GitHubLinkedServiceAdapter,
        RestServiceLinkedServiceAdapter,
        SapOpenHubLinkedServiceAdapter,
        SnowflakeLinkedServiceAdapter,
        SnowflakeV2LinkedServiceAdapter,
        DynamicsAXLinkedServiceAdapter,
        AzureDataExplorerLinkedServiceAdapter,
        KustoDatabaseLinkedServiceAdapter,
        DataWarehouseLinkedServiceAdapter,
        FabricSqlLinkedServiceAdapter,
        SqlAnalyticsEndpointLinkedServiceAdapter,
        MountedRelationalDatabaseLinkedServiceAdapter,
        AdobeExperiencePlatformLinkedServiceAdapter,
        AdobeIntegrationLinkedServiceAdapter,
        MicrosoftAccessLinkedServiceAdapter,
        CommonDataServiceLinkedServiceAdapter,
        DynamicsCrmLinkedServiceAdapter,
        InformixLinkedServiceAdapter,
        SalesforceServiceCloudLinkedServiceAdapter,
        SalesforceServiceCloudV2LinkedServiceAdapter,
        AzureMariaDBLinkedServiceAdapter,
        AzureFileStorageLinkedServiceAdapter,
        GoogleCloudStorageLinkedServiceAdapter,
        SharePointOnlineListLinkedServiceAdapter,
        SharePointOnlineFileLinkedServiceAdapter,
        AzureDatabricksDeltaLakeLinkedServiceAdapter,
        DatabricksLinkedServiceAdapter,
        EventHubsLinkedServiceAdapter,
        CognitiveServiceLinkedServiceAdapter,
        AmazonRdsForOracleAdapter,
        AmazonRdsSqlServerLinkedServiceAdapter,
        SapOdpLinkedServiceAdapter,
        SapCdcLinkedServiceAdapter,
        SapBdcLinkedServiceAdapter,
        SapOdataLinkedServiceAdapter,
        TeamDeskLinkedServiceAdapter,
        QuickbaseLinkedServiceAdapter,
        SmartsheetLinkedServiceAdapter,
        ZenDeskLinkedServiceAdapter,
        AzureSynapseLinkedServiceAdapter,
        TrinoLinkedServiceAdapter,
        WorkdayLinkedServiceAdapter,
        KafkaLinkedServiceAdapter,
        WebActivityLinkedServiceAdapter,
        AzureDataFactoryLinkedServiceAdapter,
        AzureSynapseAnalyticsLinkedServiceAdapter,
        FabricWorkspaceLinkedServiceAdapter,
        TridentSparkJobDefinitionLinkedServiceAdapter,
        FabricNotebookLinkedServiceAdapter,
        FabricAirflowLinkedServiceAdapter,
        FabricUserDataFunctionsLinkedServiceAdapter,
        FabricDataflowLinkedServiceAdapter,
        InvokeCopyJobLinkedServiceAdapter,
        SapDatasphereForAzureDataLakeStorageGen2LinkedServiceAdapter,
        OneLakeFileLinkedServiceAdapter,
        SapDatasphereForGoogleCloudStorageLinkedServiceAdapter,
        SapDatasphereForAmazonS3LinkedServiceAdapter,
        FabricSqlEndpointMetadataLinkedServiceAdapter,
        DataBuildToolJobLinkedServiceAdapter,
        DataQualityLinkedServiceAdapter,
        FabricWebLinkedServiceAdapter,


        // [Dataset]
        AzureBlobDatasetAdapter,
        AmazonS3DatasetAdapter,
        AzureSqlDWDatasetAdapter,
        AzureSqlDatasetAdapter,
        MountedRelationalDatabaseDatasetAdapter,
        SqlServerTableDatasetAdapter,
        AzureSqlMITableDatasetAdapter,
        AzureDataLakeStoreFileDatasetAdapter,
        AzureDataLakeStoreCosmosStructuredStreamFileDatasetAdapter,
        AzureDataLakeStoreGen2CosmosStructuredStreamFileDatasetAdapter,
        OracleTableDatasetAdapter,
        FileShareDatasetAdapter,
        SalesforceDatasetAdapter,
        SalesforceV2DatasetAdapter,
        RelationalTableDatasetAdapter,
        GenericCDataTableDatasetAdapter,
        ODataResourceDatasetAdapter,
        AzureMySqlDatasetAdapter,
        AzurePostgreSqlDatasetAdapter,
        AzureHorizonDBDatasetAdapter,
        AzureTableDatasetAdapter,
        AzureCosmosDatasetAdapter,
        SqlPoolTableDatasetAdapter,
        CassandraDatasetAdapter,
        AzureSearchDatasetAdapter,
        MongoDbDatasetAdapter,
        GoogleBigQueryObjectDatasetAdapter,
        GoogleBigQueryObjectV2DatasetAdapter,
        ImpalaObjectDatasetAdapter,
        ServiceNowObjectDatasetAdapter,
        ServiceNowV2ObjectDatasetAdapter,
        ODataResourceDatasetAdapter,
        Office365DatasetAdapter,
        HttpFileDatasetAdapter,
        DynamicsEntityDatasetAdapter,
        AmazonMWSObjectDatasetAdapter,
        AmazonRedshiftTableDatasetAdapter,
        SapC4CResourceDatasetAdapter,
        SapEccResourceDatasetAdapter,
        HbaseObjectDatasetAdapter,
        HiveObjectDatasetAdapter,
        KustoDatasetAdapter,
        SparkObjectDatasetAdapter,
        SapTableDatasetAdapter,
        PhoenixObjectDatasetAdapter,
        PaypalObjectDatasetAdapter,
        PostgreSqlDatasetAdapter,
        PostgreSqlV2DatasetAdapter,
        MarketoObjectDatasetAdapter,
        OracleResponsysDatasetAdapter,
        SalesforceMarketingCloudDatasetAdapter,
        PrestoObjectDatasetAdapter,
        XeroObjectDatasetAdapter,
        SquareObjectDatasetAdapter,
        ShopifyObjectDatasetAdapter,
        MagentoObjectDatasetAdapter,
        JiraObjectDatasetAdapter,
        VivaInsightsReportDatasetAdapter,
        AttioObjectDatasetAdapter,
        BitbucketTableDatasetAdapter,
        OracleFusionTableDatasetAdapter,
        WebTableDatasetAdapter,
        ConcurObjectDatasetAdapter,
        HubSpotObjectDatasetAdapter,
        ZohoObjectDatasetAdapter,
        QuickBooksObjectDatasetAdapter,
        EloquaObjectDatasetAdapter,
        CouchbaseTableDatasetAdapter,
        DrillTableDatasetAdapter,
        GreenplumTableDatasetAdapter,
        MariaDBTableDatasetAdapter,
        NetezzaTableDatasetAdapter,
        VerticaTableDatasetAdapter,
        AzureBlobFSDatasetAdapter,
        NativeMongoDbDatasetAdapter,
        MongoDbAtlasDatasetAdapter,
        AzureCosmosMongoDbApiDatasetAdapter,
        OracleServiceCloudObjectDatasetAdapter,
        GoogleAdWordsObjectDatasetAdapter,
        RestResourceDatasetAdapter,
        SapOpenHubTableDatasetAdapter,
        SnowflakeTableDatasetAdapter,
        SnowflakeV2TableDatasetAdapter,
        DynamicsAXResourceDatasetAdapter,
        ParquetDatasetAdapter,
        JsonDatasetAdapter,
        AvroDatasetAdapter,
        OrcDatasetAdapter,
        DeltaDatasetAdapter,
        IcebergDatasetAdapter,
        DelimitedTextDatasetAdapter,
        IcebergFormatAdapter,
        BinaryDatasetAdapter,
        ExcelDatasetAdapter,
        AzureDataExplorerDatasetAdapter,
        KustoDatabaseDatasetAdapter,
        EventStreamDatasetAdapter,
        DataWarehouseTableDatasetAdapter,
        FabricSqlTableDatasetAdapter,
        SqlAnalyticsEndpointDatasetAdapter,
        TeradataDatasetAdapter,
        DB2DatasetAdapter,
        OdbcDatasetAdapter,
        SapHanaDatasetAdapter,
        AdobeExperiencePlatformDatasetAdapter,
        MicrosoftAccessTableDatasetAdapter,
        CommonDataServiceEntityDatasetAdapter,
        DynamicsCrmEntityDatasetAdapter,
        InformixTableDatasetAdapter,
        SalesforceServiceCloudDatasetAdapter,
        SalesforceServiceCloudV2DatasetAdapter,
        SybaseTableDatasetAdapter,
        SapBwCubeDatasetAdapter,
        AzureMariaDBTableDatasetAdapter,
        MysqlTableDatasetAdapter,
        AzureCosmosV2DatasetAdapter,
        SharePointOnlineListResourceDatasetAdapter,
        XmlDatasetAdapter,
        AzureDatabricksDeltaLakeDatasetAdapter,
        DatabricksDatasetAdapter,
        AmazonRdsForOracleDatasetAdapter,
        AmazonRdsSqlServerTableDatasetAdapter,
        SapOdpDatasetAdapter,
        SapCdcDatasetAdapter,
        SapBdcDatasetAdapter,
        SapODataDatasetAdapter,
        TrinoDatasetAdapter,
        LakehouseTableDatasetAdapter,

        // [IntegrationRuntime]
        ManagedIntegrationRuntimeAdapter,
        ManagedLinkedIntegrationRuntimeAdapter,
        SelfHostedIntegrationRuntimeAdapter,
        AirflowIntegrationRuntimeAdapter,

        // [Trigger]
        TriggerAdapter,
        TriggerSettingsAdapter,

        // [miscellaneous]
        ParameterAdapter,
        VariableAdapter,
        LibraryVariableAdapter,
        FolderAdapter,
        TemplateAdapter,

        // [DataFlow & Transformation]
        WranglingDataflowAdapter,
        DataFlowAdapter,
        PbiDataflowAdapter,
        FlowletAdapter,
        UserDefinedFunctionLibraryAdapter,
        SourceAdapter,
        SinkAdapter,
        InputAdapter,
        OutputAdapter,
        SelectTransformationAdapter,
        FoldDownTransformationAdapter,
        ExtendTransformationAdapter,
        DeriveTransformationAdapter,
        ParseTransformationAdapter,
        SortTransformationAdapter,
        RankTransformationAdapter,
        AggregateTransformationAdapter,
        JoinTransformationAdapter,
        ConditionalSplitTransformationAdapter,
        ExistsTransformationAdapter,
        FilterTransformationAdapter,
        UnionTransformationAdapter,
        LookupTransformationAdapter,
        SurrogateKeyTransformationAdapter,
        PivotTransformationAdapter,
        UnpivotTransformationAdapter,
        WindowTransformationAdapter,
        AlterRowTransformationAdapter,
        BrowseTransformationAdapter,
        ExecuteFlowletTransformationAdapter,
        ConnectTransformationAdapter,
        AssertTransformationAdapter,
        CallTransformationAdapter,
        StringifyTransformationAdapter,
        GuardTransformationAdapter,
        CastTransformationAdapter,
        AdobeCampaignFormatAdapter,
        AdobeEventsFormatAdapter,
        AdobePrivacyFormatAdapter,
        CdmFormatAdapter,
        DeltaFormatAdapter,
        ExcelFormatAdapter,
        HiveFormatAdapter,
        SqlDBFormatAdapter,
        SqlMIFormatAdapter,
        SynapseAnalyticsFormatAdapter,
        WarehouseFormatAdapter,
        XmlFormatAdapter,
        OrcFormatAdapter,
        SnowflakeTableAdapter,
        SnowflakeV2TableAdapter,
        GroupAdapter,
        PostgreSqlAdapter,
        DelimitedTextFormatAdapter,
        AvroFormatAdapter,
        JsonFormatAdapter,
        MysqlAdapter,
        OnPremiseSqlServerFormatAdapter,
        ParquetFormatAdapter,
        RestFormatAdapter,
        RestCallFormatAdapter,
        AdxAdapter,
        DynamicsAdapter,
        DynamicsCrmAdapter,
        DataverseAdapter,
        TeamDeskAdapter,
        QuickbaseAdapter,
        CosmosSqlAdapter,
        CosmosMongoAdapter,
        SapOdpAdapter,
        SapOdataAdapter,
        SmartsheetAdapter,
        ZendeskAdapter,
        Microsoft365Adapter,
        OracleAdapter,
        WorkdayAdapter,
        EventHubsAdapter,
        KafkaAdapter,
        SalesforceAdapter,

        // [Dataset Store]
        AzureBlobStorageLocationAdapter,
        AzureBlobFSLocationAdapter,
        LakehouseLocationAdapter,
        HttpServerLocationAdapter,
        SftpLocationAdapter,
        HdfsLocationAdapter,
        AzureDataLakeLocationAdapter,
        AmazonS3LocationAdapter,
        AmazonS3CompatibleLocationAdapter,
        OracleCloudStorageLocationAdapter,
        FileServerLocationAdapter,
        FtpServerLocationLocationAdapter,
        AzureFileStorageLocationAdapter,
        GoogleCloudStorageLocationAdapter,
        SharePointOnlineFileLocationAdapter,
        SapDatasphereForAzureDataLakeStorageGen2LocationAdapter,
        OneLakeFileLocationAdapter,
        SapDatasphereForGoogleCloudStorageLocationAdapter,
        SapDatasphereForAmazonS3LocationAdapter,

        // linked service store read settings
        AzureBlobStoreReadSettingsAdapter,
        AzureDataLakeStoreReadSettingsAdapter,
        AmazonS3StoreReadSettingsAdapter,
        AmazonS3CompatibleStoreReadSettingsAdapter,
        OracleCloudStorageStoreReadSettingsAdapter,
        HttpStoreReadSettingsAdapter,
        HdfsStoreReadSettingsAdapter,
        AzureBlobFSStoreReadSettingsAdapter,
        LakehouseStoreReadSettingsAdapter,
        FtpStoreReadSettingsAdapter,
        SftpStoreReadSettingsAdapter,
        FileServerStoreReadSettingsAdapter,
        AzureFileStorageStoreReadSettingsAdapter,
        GoogleCloudStorageStoreReadSettingsAdapter,
        SharePointOnlineFileStoreReadSettingsAdapter,
        SapDatasphereForAzureDataLakeStorageGen2ReadSettingsAdapter,
        OneLakeFileReadSettingsAdapter,
        SapDatasphereForGoogleCloudStorageReadSettingsAdapter,
        SapDatasphereForAmazonS3ReadSettingsAdapter,

        // linked service store write settings
        AzureBlobStoreWriteSettingsAdapter,
        AzureBlobFSWriteSettingsAdapter,
        OneLakeFileWriteSettingsAdapter,
        LakehouseWriteSettingsAdapter,
        AzureDataLakeStoreWriteSettingsAdapter,
        FileServerStoreWriteSettingsAdapter,
        AzureFileStorageStoreWriteSettingsAdapter,
        SftpStoreWriteSettingsAdapter,
        AmazonS3WriteSettingsAdapter,
        AmazonS3CompatibleWriteSettingsAdapter,
        GoogleCloudStorageWriteSettingsAdapter,
        SharePointOnlineFileWriteSettingsAdapter,

        // dataset format read settings
        DelimitedTextFormatReadSettingsAdapter,
        BinaryFormatReadSettingsAdapter,
        JsonFormatReadSettingsAdapter,
        XmlFormatReadSettingsAdapter,
        ParquetFormatReadSettingsAdapter,

        // dataset compression read settings
        ZipDeflateCompressionReadSettingsAdapter,
        TarGZipCompressionReadSettingsAdapter,
        TarCompressionReadSettingsAdapter,

        // dataset format write settings
        DelimitedTextFormatWriteSettingsAdapter,
        JsonFormatWriteSettingsAdapter,
        AvroFormatWriteSettingsAdapter,
        OrcFormatWriteSettingsAdapter,
        ParquetFormatWriteSettingsAdapter,
        DeltaFormatWriteSettingsAdapter,
        IcebergFormatWriteSettingsAdapter,

        // Mapping artifact
        MappingArtifactAsyncAdapter,

        // ADF DataMapper Artifact
        AdfDataMapperArtifactAsyncAdapter,

        // Airflow entity
        AirflowEntityAdapter,

        // Trident resources
        PbiNotebookAdapter,
        TridentNotebookActivityAdapter,
        TridentSparkJobDefinitionActivityAdapter,
        InvokeCopyJobActivityAdapter,
        InvokeDataBuildToolJobActivityAdapter,
        InvokeDataQualityActivityAdapter,
        ApiIntegrationActivityAdapter,
        FabricActionsActivityAdapter,
        BusinessActionsActivityAdapter,
        FabricApprovalActivityAdapter,

        // Fabric Copy job
        CopyJobAdapter,
        CopyJobActivityAsyncAdapter
    ];
}
